<div class="audioRecordsContainer">
    <i *ngIf="bodySpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
    <span class="sr-only">Loading...</span>
    <div class="header hdr d-flex">
        <h5 class="h5-class"> <span class="animateH5">Voice Mail Analytics</span></h5>
        <div class="inputContainer hdr-inputContainer">
            <!-- <div class="radioContainer" *ngIf="usersRole === 102">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="call_type" value="inbound" id="inlineRadio1"
                        [(ngModel)]="bound" (change)="boundChange()">
                    <label class="form-check-label" for="inlineRadio1">
                        Inbound
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="call_type" value="outbound" id="inlineRadio2"
                        [(ngModel)]="bound" (change)="boundChange()">
                    <label class="form-check-label" for="inlineRadio2">
                        Outbound
                    </label>
                </div>
            </div> -->
            <div class="input-group tblSelect">
                <select class="form-select audioTableSearchSelect" #searchSelect (change)="selectTableData()">
                    <option value="default">Default</option>
                    <option value="fileid">Call ID</option>
                    <option value="keyword">Keyword</option>
                    <option value="date">Date Range </option>
                </select>
                <input type="text" class="form-control audioTableSearchInput" *ngIf="selectedSearchOption === 'date'"
                    ngxDaterangepickerMd [autoApply]="true" [showDropdowns]="true" placeholder="Select Date Range"
                    (change)="getDateSearchData($event)" [readonly]="true" />
                <input type="search" [(ngModel)]="tableSearch" (ngModelChange)="this.tableSearchUpdate.next($event)"
                    autocomplete="off" *ngIf="selectedSearchOption !== 'date'" placeholder="Search"
                    class="form-control audioTableSearchInput" name="searchInput" id="searchInput">
                <button class="btn btn-primary audioTableSearchBtn"><i
                        class="fa-solid fa-magnifying-glass"></i></button>
            </div>
        </div>
    </div>
    <div class="container-fluid ">
        <!-- <div class="inputContainer">
            <div class="radioContainer" *ngIf="this.userDetails?.role === 102">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="call_type" value="inbound" id="inlineRadio1"
                        [(ngModel)]="bound" (change)="boundChange()">
                    <label class="form-check-label" for="inlineRadio1">
                        Inbound
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="call_type" value="outbound" id="inlineRadio2"
                        [(ngModel)]="bound" (change)="boundChange()">
                    <label class="form-check-label" for="inlineRadio2">
                        Outbound
                    </label>
                </div>
            </div>
            <div class="input-group tblSelect">
                <select class="form-select audioTableSearchSelect" #searchSelect (change)="selectTableData()">
                    <option value="default">Default</option>
                    <option value="keyword">Keyword</option>
                    <option value="date">Date Range </option>
                </select>
                <input type="text" class="form-control audioTableSearchInput" *ngIf="selectedSearchOption === 'date'"
                    ngxDaterangepickerMd [autoApply]="true" [showDropdowns]="true" placeholder="Select Date Range"
                    (change)="getDateSearchData($event)" [readonly]="true" />
                <input type="search" [(ngModel)]="tableSearch" (ngModelChange)="this.tableSearchUpdate.next($event)"
                    autocomplete="off" *ngIf="selectedSearchOption !== 'date'" placeholder="search"
                    class="form-control audioTableSearchInput" name="searchInput" id="searchInput">
                <button class="btn btn-primary audioTableSearchBtn"><i
                        class="fa-solid fa-magnifying-glass"></i></button>
            </div>
        </div> -->
        <div class="table-responsive">
            <div class="card tblCrd">
                <table class="table text-center" id="audioTable">
                    <thead class="tblHead">
                        <tr>
                            <!-- <th class="callLogHead">
                                <i class="fa-solid fa-check select-row-icon" (click)="showMultiSelectOption()"
                                    tooltip="Select Multiple" [options]="myOptions"></i>
                                <span>
                                    <span class="form-check multi-select-form-check selectAll-form-check" *ngIf="showMultiSelect">
                                        <input type="checkbox" class="form-check-input selectAll-form-check-input" (change)="selectAll()"
                                            [checked]="selectedAllIndex">
                                    </span>
                                </span>
                                <i class="fa-regular fa-trash-can audioIcons iconAction multi-trash"
                                    tooltip="Delete Record" [options]="myOptions" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal" *ngIf="showMultiSelect"></i>call log
                            </th> -->
                            <th class="callLogHead">voice call log
                            </th>
                            <th class="callCategoryHead">category</th>
                            <th>sentiment</th>
                            <!-- <th *ngIf="clientcodeId !='655db3dfd5eed60008593da5'" class="progressHead">keyword match</th> 
                            <th class="progressHead"> {{ clientcodeId=='6691253dc813650008437ba0' ? 'Overall Score' : 'QA Score' }}</th>
                            <th *ngIf="clientcodeId=='6691253dc813650008437ba0'">Mandatory Regulatory Score</th>
                            <th class="progressHead" *ngIf="clientcodeId != '6691253dc813650008437ba0'">Actual score</th>
                           
                             <ng-container *ngIf="clientcodeId == '6691253dc813650008437ba0'">
                                <th class="progressHead">Profanity</th>
                                <th class="progressHead">Assurance</th>
                             </ng-container>
                            
                            <th class="progressHead" *ngIf="clientcodeId != '6691253dc813650008437ba0'">Agent Speech Speed</th>-->
                            <th class="">transcript</th>
                            <th class="">questions</th>
                            <!-- <th class="otherHead">REPORT</th> 
                             <ng-container *ngIf="clientcodeId != '6691253dc813650008437ba0'">
                            <th>soft hold</th>
                            <th class="">dead air</th></ng-container>-->
                            <!-- <th class="">mute</th> -->
                            <th class="">customer</th>
                            <th class="" style="min-width: 100px">agent</th>
                            <th class="timeTh" (click)="openModalDialog()" (click)="sortFun()">uploaded date
                                <i class="fa fa-sort-asc" *ngIf="!sortingShow" aria-hidden="true"></i>
                                <i class="fa fa-sort-desc" *ngIf="sortingShow" aria-hidden="true"></i>
                            </th>
                            <th class="action">action</th>
                        </tr>
                    </thead>
                    <tbody>
                        @if(tableData.length === 0 && !bodySpinner){
                            <tr class="text-center">
                                <td colspan="14">
                                    <div class="justify-content-center align-items-center">
                                      <p class="noRecord">No Records Found</p>
                                    </div>
                                </td>
                            </tr>
                        }@else{
                            <tr *ngFor="let result of tableData | paginate :{itemsPerPage:limit,
                                currentPage:page,
                                totalItems:records1.total_records}; index as i" (click)="tableBack(i)"
                                [ngClass]="{'selectedClass':i===tableTrVar, 'unread': result.read==='N'}">
                                <td class="callLogTd" [ngClass]="{'callLogTd2':showModalAudioTag}">
                                    <!-- <span>
                                        <span class="form-check multi-select-form-check" *ngIf="showMultiSelect">
                                            <input type="checkbox" class="form-check-input" (change)="removeUnselected(i)"
                                                [(ngModel)]="deleteIndexArray[i]">
                                        </span>
                                    </span> -->
                                    <span class="callLogs" *ngIf="i !== audioFileIndex">
                                        <i class="fa-regular fa-circle-play iconPlay" (click)="playAudioFile(i)"
                                            tooltip="Play" [options]="myOptions"></i>
                                        {{result.display_file_name}}
                                    </span>
                                    <i *ngIf="audioSpinner && i === audioFileIndex"
                                        class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                    <audio [src]="audioSafeUrl" *ngIf="i === audioFileIndex" (play)="audioTagChange('play')"
                                        (pause)="audioTagChange('pause')" class="audio-file-class" id="audioTagAnalysis"
                                        controls>
                                    </audio>
                                    <i *ngIf="i === audioFileIndex" (click)="closeAudioTag()" title="close"
                                        class="fa-solid fa-xmark audioTagExitIcon" aria-label="Close"></i>
                                </td>
                                <td class="callCategoryTd">
                                    <span class="categoryPara-null">-</span>
                                    <!-- <p class="categoryPara" *ngIf="result.call_category.length > 0">
                                        {{result.call_category[0]?.category}}</p>
                                    <p class="categoryPara-null" *ngIf="result.call_category.length === 0"><b>-</b></p>
                                    <i class="fa fa-eye" aria-hidden="true" tooltip="View CallCategory Details"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#callCategoryModal"
                                        (click)="CallCategoryIndex(i)"></i> -->
    
                                    <!-- <span class="categoryPara-null" *ngIf="result.call_category.length === 0">-</span>
                                    <span class="score-progress" *ngIf="result.call_category.length !== 0">
                                        <span class="categoryPara" *ngIf="result.category_matched?.length !==0"
                                            [ngStyle]="{'background-color': result.category_matched[0].color}">{{result.category_matched[0].category}}</span>
                                        <span class="categoryPara-null" *ngIf="result.category_matched.length ===0">-</span>
                                        <i class="fa fa-eye" aria-hidden="true" tooltip="View CallCategory Details"
                                            [options]="myOptions" data-bs-toggle="modal" data-bs-target="#callCategoryModal"
                                            (click)="CallCategoryIndex(i)"></i>
                                    </span> -->
                                </td>
                                <!-- <ng-container *ngIf="clientcodeId =='655db3dfd5eed60008593da5' else OtherClient"> 
                                    <td
                                    *ngIf="result?.file_id?.$oid !=='63e106b30c11eb00f2840320' && result?.file_id?.$oid !=='63e103070c11eb00daaf4d05' && result?.file_id?.$oid !=='63e1018b0c11eb00ce4c9728'">
                                    <ng-container *ngIf="result.customer_negative <= result.customer_positive else negativeIcon">
                                    <i class="fa-regular fa-face-smile audioIcons iconSmile" tooltip="View Sentiment Score"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#sentimentModal"
                                        (click)="getSentimentFun(i)" (click)="sentimentHeading('customer')"
                                        (click)="sentimentWordsHeading('positive')"></i>
                                    </ng-container>
                                   <ng-template #negativeIcon>
                                    <i class="fa-regular fa-face-frown audioIcons iconSad" tooltip="View Sentiment Score"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#sentimentModal"
                                        (click)="getSentimentFun(i)" (click)="sentimentHeading('customer')"
                                        (click)="sentimentWordsHeading('positive')"></i>
                                    </ng-template>    
                                </td>
                                <td
                                    *ngIf="result?.file_id?.$oid ==='63e106b30c11eb00f2840320' || result?.file_id?.$oid ==='63e103070c11eb00daaf4d05' || result?.file_id?.$oid ==='63e1018b0c11eb00ce4c9728' ">
                                    <i class="fa-regular fa-face-frown audioIcons iconSad" tooltip="View Sentiment Score"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#sentimentModal"
                                        (click)="getSentimentFun(i)" (click)="sentimentHeading('overall')"
                                        (click)="sentimentWordsHeading('positive')"></i>
                                </td>
                                 </ng-container> -->
                                <!-- <ng-template #OtherClient>-->
                                    <td> 
                                        <ng-container [ngSwitch]="result.sentiments_icon">
                                            <ng-container *ngSwitchCase="'neutral'">
                                              <i class="fa-regular fa-face-meh audioIcons iconMeh" tooltip="View Sentiment"
                                              [options]="myOptions" data-bs-toggle="modal" data-bs-target="#sentimentModal"
                                              (click)="getSentimentFun(i)" (click)="sentimentHeading('customer')"
                                              (click)="sentimentWordsHeading('positive')"></i>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'positive'">
                                           <i class="fa-regular fa-face-smile audioIcons iconSmile" tooltip="View Sentiment"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#sentimentModal"
                                        (click)="getSentimentFun(i)" (click)="sentimentHeading('customer')"
                                        (click)="sentimentWordsHeading('positive')"></i>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'negative'">
                                                <i  class="fa-regular fa-face-frown audioIcons iconSad" tooltip="View Sentiment"
                                                [options]="myOptions" data-bs-toggle="modal" data-bs-target="#sentimentModal"
                                                (click)="getSentimentFun(i)" (click)="sentimentHeading('customer')"
                                                (click)="sentimentWordsHeading('positive')"></i>
                                            </ng-container>
                                      </ng-container>
                                    </td>
                                    <!-- <td
                                    *ngIf="result?.file_id?.$oid !=='63e106b30c11eb00f2840320' && result?.file_id?.$oid !=='63e103070c11eb00daaf4d05' && result?.file_id?.$oid !=='63e1018b0c11eb00ce4c9728'">
                                    <i *ngIf="result.negative_sentiment < result.positive_sentiment && result.neutral_sentiment < result.positive_sentiment"
                                        class="fa-regular fa-face-smile audioIcons iconSmile" tooltip="View Sentiment Score"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#sentimentModal"
                                        (click)="getSentimentFun(i)" (click)="sentimentHeading('customer')"
                                        (click)="sentimentWordsHeading('positive')"></i>
                                    <i *ngIf="result.positive_sentiment < result.neutral_sentiment && result.negative_sentiment < result.neutral_sentiment || result.positive_sentiment === result.negative_sentiment"
                                        class="fa-regular fa-face-meh audioIcons iconMeh" tooltip="View Sentiment Score"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#sentimentModal"
                                        (click)="getSentimentFun(i)" (click)="sentimentHeading('customer')"
                                        (click)="sentimentWordsHeading('positive')"></i>
                                    <i *ngIf="result.positive_sentiment < result.negative_sentiment && result.neutral_sentiment < result.negative_sentiment"
                                        class="fa-regular fa-face-frown audioIcons iconSad" tooltip="View Sentiment Score"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#sentimentModal"
                                        (click)="getSentimentFun(i)" (click)="sentimentHeading('customer')"
                                        (click)="sentimentWordsHeading('positive')"></i>
                                </td> -->
                                <!-- <td
                                    *ngIf="result?.file_id?.$oid ==='63e106b30c11eb00f2840320' || result?.file_id?.$oid ==='63e103070c11eb00daaf4d05' || result?.file_id?.$oid ==='63e1018b0c11eb00ce4c9728' ">
                                    <i class="fa-regular fa-face-frown audioIcons iconSad" tooltip="View Sentiment Score"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#sentimentModal"
                                        (click)="getSentimentFun(i)" (click)="sentimentHeading('customer')"
                                        (click)="sentimentWordsHeading('positive')"></i>
                                </td> -->
                              <!--  </ng-template> -->
                                
    
                               <!-- <td class="progressTd" *ngIf="clientcodeId !='655db3dfd5eed60008593da5'">
                                    <div class="progress">
                                        <div [ngClass]="{'progress-bar0': result.keyword_percentage == 0, 'progress-barGreen':result.keyword_percentage > 74, 'progress-barRed':result.keyword_percentage > 0 && result.keyword_percentage < 50}"
                                            class="progress-bar" role="progressbar"
                                            attr.style="width:{{result.keyword_percentage}}%"
                                            attr.aria-valuenow="{{result.keyword_percentage}}" attr.aria-valuemin="{{0}}"
                                            aria-valuemax="100"> {{result.keyword_percentage | number:'1.0-0'}}%</div>
                                    </div>
                                    <i class="fa fa-eye" aria-hidden="true" tooltip="View Keyword Details"
                                        [options]="myOptions" data-bs-toggle="modal"
                                        data-bs-target="#keywordPercentageModal"
                                        (click)="getReportData(i, 'keywordPercentage')"></i>
                                </td> -->
                                <!-- <td class="progressTd">
                                 
                                  
                                   <ng-container [ngSwitch]="drawProgressBar(validate_QA_Score(result['metrics_matches'],result.metric_score))">
                                            
                                            <ng-container *ngSwitchCase="'progress-bar0'">
                                                <div class="progress">
                                                <div class="progress-bar progress-bar0" role="progressbar" attr.aria-valuenow="{{validate_QA_Score(result['metrics_matches'],result.metric_score)}}"
                                                        aria-valuemin="0" aria-valuemax="100"
                                                        attr.style="width:{{validate_QA_Score(result['metrics_matches'],result.metric_score)}}%">
                                                        {{validate_QA_Score(result['metrics_matches'],result.metric_score)}}
                                                   
                                                </div>  
                                                </div>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'progress-barLightGreen'">
                                                <div class="progress">
                                                <div class="progress-bar progress-barLightGreen" role="progressbar" attr.aria-valuenow="{{validate_QA_Score(result['metrics_matches'],result.metric_score)}}"
                                                        aria-valuemin="0" aria-valuemax="100"
                                                        attr.style="width:{{validate_QA_Score(result['metrics_matches'],result.metric_score)}}%">
                                                        {{validate_QA_Score(result['metrics_matches'],result.metric_score)}}
                                                   
                                                </div>  
                                                </div>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'progress-barLightBlue'">
                                                <div class="progress">
                                                <div class="progress-bar progress-barLightBlue" role="progressbar" attr.aria-valuenow="{{validate_QA_Score(result['metrics_matches'],result.metric_score)}}"
                                                        aria-valuemin="0" aria-valuemax="100"
                                                        attr.style="width:{{validate_QA_Score(result['metrics_matches'],result.metric_score)}}%">
                                                        {{validate_QA_Score(result['metrics_matches'],result.metric_score)}}
                                                    
                                                </div>  
                                                </div>
                                            </ng-container>
                                            
                                            <ng-container *ngSwitchCase="'progress-barGreen'">
                                                <div class="progress">
                                                <div class="progress-bar progress-barGreen" role="progressbar" attr.aria-valuenow="{{validate_QA_Score(result['metrics_matches'],result.metric_score)}}"
                                                        aria-valuemin="0" aria-valuemax="100"
                                                        attr.style="width:{{validate_QA_Score(result['metrics_matches'],result.metric_score)}}%">
                                                        {{validate_QA_Score(result['metrics_matches'],result.metric_score)}}
                                                    
                                                </div>  
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                      
                                       
                                 
                                    <i class="fa fa-eye" aria-hidden="true" tooltip="View Metric Details"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#qaMetricsModal"
                                        (click)="getQAMetricsData(i)"></i>
                                </td> -->
                                <!-- <td class="progressTd">
                                    
                                    <ng-container [ngSwitch]="drawProgressBar(validate_Mandatory_QA_Score(result?.llm_total_score))">
                                            
                                        <ng-container *ngSwitchCase="'progress-bar0'">
                                            <div class="progress">
                                            <div class="progress-bar progress-bar0" role="progressbar" attr.aria-valuenow="{{validate_Mandatory_QA_Score(result.llm_total_score)}}"
                                                    aria-valuemin="0" aria-valuemax="100"
                                                    attr.style="width:{{validate_Mandatory_QA_Score(result.llm_total_score)}}%">
                                                    {{validate_Mandatory_QA_Score(result.llm_total_score)}}
                                               
                                            </div>  
                                            </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'progress-barLightGreen'">
                                            <div class="progress">
                                            <div class="progress-bar progress-barLightGreen" role="progressbar" attr.aria-valuenow="{{validate_Mandatory_QA_Score(result.llm_total_score)}}"
                                                    aria-valuemin="0" aria-valuemax="100"
                                                    attr.style="width:{{validate_Mandatory_QA_Score(result.llm_total_score)}}%">
                                                    {{validate_Mandatory_QA_Score(result.llm_total_score)}}
                                               
                                            </div>  
                                            </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'progress-barLightBlue'">
                                            <div class="progress">
                                            <div class="progress-bar progress-barLightBlue" role="progressbar" attr.aria-valuenow="{{validate_Mandatory_QA_Score(result.llm_total_score)}}"
                                                    aria-valuemin="0" aria-valuemax="100"
                                                    attr.style="width:{{validate_Mandatory_QA_Score(result.llm_total_score)}}%">
                                                    {{validate_Mandatory_QA_Score(result.llm_total_score)}}
                                                
                                            </div>  
                                            </div>
                                        </ng-container>
                                        
                                        <ng-container *ngSwitchCase="'progress-barGreen'">
                                            <div class="progress">
                                            <div class="progress-bar progress-barGreen" role="progressbar" attr.aria-valuenow="{{validate_Mandatory_QA_Score(result.llm_total_score)}}"
                                                    aria-valuemin="0" aria-valuemax="100"
                                                    attr.style="width:{{validate_Mandatory_QA_Score(result.llm_total_score)}}%">
                                                    {{validate_Mandatory_QA_Score(result.llm_total_score)}}
                                                
                                            </div>  
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                    <i class="fa fa-eye" aria-hidden="true" tooltip="View Mandatory Regulatory Score"
                                    [options]="myOptions" data-bs-toggle="modal" data-bs-target="#MandatoryRegulatoryModal"
                                    (click)="getMandatoryRegulatorQAMetricsData(i)"></i>
                                </td>
                                <td class="progressTd">{{result?.qa_score}}</td> -->
                                <!-- <td class="progressTd" *ngIf="clientcodeId !='5fa3b477e65cec000972aeda' && clientcodeId !='663385d09c40360009e8e0b0' && clientcodeId !='666809d2a6cf4900089a8ac3' && clientcodeId!='6691253dc813650008437ba0' && clientcodeId !='6333c65a8aa7020008142fcc' && clientcodeId !='63de22df756852000760819c' && clientcodeId !='5f434c0d93bd2600072a87e4'">
                                    {{result?.language_proficiency_qa_category_data?.english_lang_code}}:{{result?.language_proficiency_qa_category_data?.english_lang_per | number : '1.0-2'}},
                                    {{result?.language_proficiency_qa_category_data?.hindi_lang_code}}:{{result?.language_proficiency_qa_category_data?.hindi_lang_per | number : '1.0-2'}}
                                </td> -->
                                <!-- <ng-container>
                                    <td>
                                        <span class="badge"  [options]="myOptions"  [tooltip]="showMatchKeywords(result?.metrics_matches, 'Profanity')"
                                        [ngClass]="drawBadge(result?.metrics_matches, 'Profanity') > 0 ? 'qa-param-green' : 'qa-param-red'">
                                        {{ drawBadge(result?.metrics_matches, 'Profanity') }}
                                        </span>
                                      
                                    
                                         
                                         
                                    </td>
                                    <td>
                                        <span  class="badge"  [options]="myOptions"  [tooltip]="showMatchKeywords(result?.metrics_matches, 'Assurance')"
                                         [ngClass]="drawBadge(result?.metrics_matches, 'Assurance') > 0 ? 'qa-param-green' : 'qa-param-red'">
                                          {{ drawBadge(result?.metrics_matches, 'Assurance') }}
                                         </span>
    
                                     
                                       
                                    </td>
                                    </ng-container> -->
                                <!-- <ng-container *ngIf="clientcodeId!='6691253dc813650008437ba0'">
                                <td class="progressTd" *ngIf="result.speech_rate?.ros">
                                    <img class="speech-rate-image-class cheeta "
                                        *ngIf="result.speech_rate?.ros?.toLowerCase() === 'fast' "
                                        src="../../../assets/images/CA Icon - Cheeta.png" alt="fast image"
                                        tooltip="ROS : Fast , WPM : {{result.speech_rate?.wpm}}" [options]="myOptions">
                                    <img class="speech-rate-image-class "
                                        *ngIf="result.speech_rate?.ros?.toLowerCase() === 'normal' "
                                        src="../../../assets/images/CA Icon - Man Walking.png" alt="medium image"
                                        tooltip="ROS : Normal , WPM : {{result.speech_rate?.wpm}}" [options]="myOptions">
                                    <img class="speech-rate-image-class "
                                        *ngIf="result.speech_rate?.ros?.toLowerCase() === 'slow' "
                                        src="../../../assets/images/CA Icon - Snail.png" alt="normal image"
                                        tooltip="ROS : Slow , WPM : {{result.speech_rate?.wpm}}" [options]="myOptions">
                                </td>
                                <td class="progressTd" *ngIf="!result.speech_rate?.ros">
                                   
                                    <img class="speech-rate-image-class cheeta "
                                        *ngIf="result?.speech_rate?.toLowerCase() === 'fast' "
                                        src="../../../assets/images/CA Icon - Cheeta.png" alt="fast image"
                                        tooltip="ROS : Fast , WPM : 140" [options]="myOptions">
                                    <img class="speech-rate-image-class "
                                        *ngIf="result?.speech_rate?.toLowerCase() === 'normal' "
                                        src="../../../assets/images/CA Icon - Man Walking.png" alt="medium image"
                                        tooltip="ROS : Normal , WPM : 140" [options]="myOptions">
                                    <img class="speech-rate-image-class "
                                        *ngIf="result?.speech_rate?.toLowerCase() === 'slow' "
                                        src="../../../assets/images/CA Icon - Snail.png" alt="normal image"
                                        tooltip="ROS : Slow , WPM : 140" [options]="myOptions">
                                    <img class="speech-rate-image-class " *ngIf="!result?.speech_rate"
                                        src="../../../assets/images/CA Icon - Man Walking.png" alt="normal image"
                                        tooltip="ROS : Normal , WPM : 140" [options]="myOptions">
                                </td>
                             </ng-container> -->
                                <td><i class="fa fa-file-text audioIcons iconFile" data-bs-toggle="modal"
                                        data-bs-target="#transcriptModal" tooltip="View Transcript" [options]="myOptions"
                                        (click)="modalHeading('transcript')" (click)="hideMinimizedModal('Transcript')"
                                        (click)="getTranscriptFun(i, 'transcript')"></i>
                                </td>
                                 <td><i class="fa-solid fa-circle-question audioIcons iconFile" data-bs-toggle="modal"
                                        data-bs-target="#questionModal" tooltip="View Questions" [options]="myOptions"
                                        (click)="modalHeading('questions')" (click)="hideMinimizedModal('questions')"
                                        (click)="getTranscriptFun(i, 'questions')"></i>
                                </td>
                                <!-- <td><i class="fa-regular fa-file audioIcons iconFile" tooltip="View Review/Analysis Report"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#reportModal"
                                        (click)=" getReportData(i, 'report')"></i>
                                </td> -->
                                <!-- <ng-container *ngIf="clientcodeId != '6691253dc813650008437ba0'">
                                <td>
                                
                                  <ng-container [ngSwitch]="validateSoftHoldIcon(result.hold_key)">
                                        <span *ngSwitchCase="'neutral-icon'">
                                            <img  class="neutral-icon"
                                            src="../../../assets/images/CA Neutral Call Icon .png" alt="" tooltip="Nil"
                                            [options]="myOptions">
                                        </span>
                                        <span *ngSwitchCase="'hold-icon'">
                                            <i class="fa-regular fa-circle-pause hold-icon" (click)="getSoftHoldData(i)"
                                            data-bs-toggle="modal"
                                             data-bs-target="#softHoldModal" tooltip="Soft Hold" [options]="myOptions"></i>
                                        </span>
                                    </ng-container>  
                                   
                                
                                    
                                 
                                </td>
                                 <td>
                                    <img *ngIf="(result.dead_air[0]?.dead_air_count && result.dead_air[0]?.dead_air_count !== 0) || result.dead_air?.category === 'deadair' "
                                        (click)="getDeadAirData(i)" data-bs-toggle="modal" data-bs-target="#deadAirModal"
                                        class="dead-air-icon callIcon" tooltip="Dead Air" [options]="myOptions"
                                        src="../../../assets/images/CA Dead Air Call Icon.png" alt="">
                                    <i class="fa-regular fa-circle-pause hold-icon" (click)="getDeadAirData(i)"
                                        *ngIf="result.dead_air?.category === 'hold'" data-bs-toggle="modal"
                                        data-bs-target="#deadAirModal" tooltip="Hold" [options]="myOptions"></i>
                                    <img *ngIf="(!result.dead_air[0]?.dead_air_count && result.dead_air[0]?.dead_air_count === 0) || result.dead_air?.message || result.dead_air?.category === null"
                                        class="neutral-icon" src="../../../assets/images/CA Neutral Call Icon .png"
                                        alt="" tooltip="Nil" [options]="myOptions">
                                </td>  
                                </ng-container> -->
                                <!-- <td>
                                     <i class="fa-solid fa-microphone-lines-slash"></i>  
                                    <img class="neutral-icon" src="../../../assets/images/CA Neutral Call Icon .png"
                                        alt="" tooltip="Nil" [options]="myOptions">
                                </td> -->
                                <td>{{result.caller_name}}</td>
                                <td>{{result.agent_name}}</td>
                                <td class="timeTd">{{result.time_stamp | date:'medium'}}</td>
                                <!-- <td class="actionTd"><i class="fa-regular fa-envelope audioIcons iconAction" tooltip="Email"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#emailModal"
                                        (click)="getEmailData(i)"></i>
                                    <i class="fa fa-language audioIcons iconAction" aria-hidden="true" tooltip="Translate"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#translateModal"
                                        (click)="getTranslateDataFun_1(i)"></i>
                                    <i class="fa-solid fa-download audioIcons iconAction" tooltip="Download Report"
                                        [options]="myOptions" (click)=" getReportData(i,'download')"
                                        *ngIf="i !== getDownloadIndex"></i>
                                    <i class="fa-solid fa-download audioIcons iconAction" tooltip="Download Report"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#reportModal"
                                        (click)=" getReportData(i, 'report')"></i>
                                    <i class="fa fa-circle-notch fa-spin" *ngIf="i===getDownloadIndex && spinner"></i>
                                    <i class="fa-solid fa-circle-info audioIcons iconAction" tooltip="File Info"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#RecordDeleteModal"
                                        (click)="getInfoData(i)"></i>
                                    <i class="fa-regular fa-trash-can audioIcons iconAction" tooltip="Delete Record"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#exampleModal"
                                        (click)="getIndex(i)" *ngIf="usersRole !== 101"></i>
                                </td> -->
                            <td class="actionTd">
                                <span (click)="getIndex(i)" *ngIf="usersRole !== 101"> <i class="fa-regular fa-trash-can audioIcons iconAction"
                                            tooltip="Delete Record" [options]="myOptions" data-bs-toggle="modal"
                                            data-bs-target="#exampleModal"></i></span>
                            </td>
                                <!--<td class="actionTd"[ngClass]="{'translate-class':i===actionIconsIndex, 'translate-class2':i!==actionIconsIndex}">
                                    <nav class="action-nav">
                                        <i class="fa-solid fa-angles-right action-trigger-icons" tooltip="show more"
                                            [options]="myOptions" *ngIf=" i!==actionIconsIndex"
                                            (click)="showActionIconsFun('show',i)"></i>
                                        <i class="fa-solid fa-angles-left action-trigger-icons" tooltip="hide"
                                            [options]="myOptions" *ngIf="showActionIcons && i===actionIconsIndex"
                                            (click)="showActionIconsFun('hide',-1)"></i>
                                        <i class="background-action-icon"></i>
                                        <i class="fa-regular fa-envelope audioIcons iconAction action-icon-float-class"
                                            tooltip="Email" [options]="myOptions" data-bs-toggle="modal"
                                            data-bs-target="#emailModal" (click)="getEmailData(i)"></i>
                                        <i class="fa fa-language audioIcons iconAction action-icon-float-class"
                                            aria-hidden="true" tooltip="Translate" [options]="myOptions"
                                            data-bs-toggle="modal" data-bs-target="#translateModal"
                                            (click)="getTranslateDataFun_1(i)"></i>
                                       
                                        <i class="fa-solid fa-download audioIcons iconAction action-icon-float-class"
                                            tooltip="Download Report" [options]="myOptions" data-bs-toggle="modal"
                                            data-bs-target="#reportModal" (click)=" getReportData(i, 'report')"></i>
                                     
                                        <i class="fa-solid fa-circle-info audioIcons iconAction action-icon-float-class"
                                            tooltip="File Info" [options]="myOptions" data-bs-toggle="modal"
                                            data-bs-target="#RecordDeleteModal" (click)="getInfoData(i)"></i>
                                        <i class="fa-regular fa-trash-can audioIcons iconAction action-icon-float-class"
                                            tooltip="Delete Record" [options]="myOptions" data-bs-toggle="modal"
                                            data-bs-target="#exampleModal" (click)="getIndex(i)"
                                            *ngIf="usersRole !== 101"></i>
                                    </nav> 
                                </td>-->
                            </tr>
                        }
                      
                       
                    </tbody>
                </table>
            </div>
        </div>
        <div class="paginationRecords" *ngIf="tableData.length > 0">
             <div class="d-flex align-items-center">
                <span class="col-md-6 pagination-records">
                    Showing {{showingRecords}} of {{records1.total_records}} records
                </span>
                <span class="col-md-6 pull-right">
                     
                        <pagination-controls #pagination [maxSize]="7" [responsive]="true" [autoHide]="true"
                            [directionLinks]="true" (pageChange)="pageChanged($event)">

                        </pagination-controls>
                   
                </span>
            </div>
        </div>
    </div>
    <div class="minimized-transcript-modal" *ngIf="transcriptMinimizedBoolean">
        <div class="modal-header">
            <h4 class="modal-title">{{transcriptMinimizedHeader}}</h4>
            <div class="modal-header-second-part">
                <i class="fa-solid fa-maximize min-max-icon" data-bs-toggle="modal" data-bs-target="#transcriptModal"
                    (click)="hideMinimizedModal('Transcript')" tooltip="Maximize" [options]="myOptions"></i>
                <i class="fa-solid fa-xmark exitIcon close " tooltip="Close" [options]="myOptions"
                    (click)="clearKeywordDetailsTranscriptModal()" aria-label="Close"
                    (click)="hideMinimizedModal('Transcript')"></i>
            </div>
        </div>
    </div>
    <!--Transcript Modal window -->
    <div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="transcriptModal">
        <div class="modal-dialog modal-dialog-scrollable {{modalScreenSize}} modal-xl transcriptModalWindow">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"><img src="../../../../assets/images/notes_ai_icon.svg" width="24" height="24">&nbsp; AI Generated</h4>
                    <div class="modal-header-second-part">
                        <i class="fa-solid fa-window-minimize min-max-icon" title="Minimize"
                            (click)="showMinimizedModal('Transcript')" data-bs-dismiss="modal" aria-label="Close"></i>
                        <i class="fa-solid fa-up-right-and-down-left-from-center min-max-icon" title="Full Screen"
                            *ngIf="!modalScreenSize" (click)="modalFullScreen('max')"></i>
                        <i class="fa-solid fa-down-left-and-up-right-to-center min-max-icon" title="Restore Down"
                            *ngIf="modalScreenSize" (click)="modalFullScreen('min')"></i>
                        <i class="fa-solid fa-xmark exitIcon close " title="Close"
                            (click)="clearKeywordDetailsTranscriptModal()" data-bs-dismiss="modal"
                            aria-label="Close"></i>
                    </div>
                </div>
                <div class="modal-body">
                    <ul class="nav nav-pills nav-justified border-bottom modalTitileTab" role="tablist">
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'summary'}" href="#nav-summary"
                                data-bs-toggle="tab" role="tab" id="summary" (click)="modalHeading('summary')"
                                (click)="getTranscriptFun(fileIndex, 'transcript')">Voice Mail Call Summary</a>
                        </li>
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'transcript'}" href="#nav-transcript"
                                data-bs-toggle="tab" id="transcript" role="tab" (click)="modalHeading('transcript')"
                                (click)="getTranscriptFun(fileIndex, 'transcript')">Transcript</a>
                        </li>
                        <!-- <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'dialogue'}" href="#nav-dialogue"
                                data-bs-toggle="tab" id="dialogue" role="tab" (click)="modalHeading('dialogue')"
                                (click)="getTranscriptFun(fileIndex, 'dialogue')" aria-current="page">Dialogue</a>
                        </li> -->
                      <!--   <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'questions'}" href="#nav-questions"
                                data-bs-toggle="tab" role="tab" id="questions" (click)="modalHeading('questions')"
                                (click)="getTranscriptFun(fileIndex, 'questions')">Questions</a>
                        </li>
                       <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'alertKeywords'}"
                                href="#nav-alertKeywords" data-bs-toggle="tab" role="tab" id="alertKeywords"
                                (click)="modalHeading('alertKeywords')"
                                (click)="getTranscriptFun(fileIndex, 'transcript')">Alert Keywords</a>
                        </li>
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'keyword'}" href="#nav-keyword"
                                #keywordId data-bs-toggle="tab" id="keyword" role="tab"
                                (click)="modalHeading('keyword')"
                                (click)="getTranscriptFun(fileIndex, 'transcript')">Extract Keywords/Phrases</a>
                        </li>
                        <li class="nav-item border-bottom border-2 modalTitile">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'mostUsedWords'}"
                                href="#nav-mostUsedWords" data-bs-toggle="tab" role="tab" id="mostUsedWords"
                                (click)="modalHeading('mostUsedWords')"
                                (click)="getTranscriptFun(fileIndex, 'transcript')">Most Used Words</a>
                        </li>-->
                    </ul>
                    <div class="modal-subtitle modal-subtitle2 border-bottom" *ngIf="showModal != 'dialogue'">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-8 tab-head">
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'transcript'">Raw Transcript</h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'keyword'">Keyword/Phrases
                                        {{" - Keyword Percentage - "+"( "+(transcriptModalData_T.keywords_percentage |
                                        number:'1.0-1')+"% )" }}</h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'alertKeywords'">Alert Keywords
                                    </h4>
                                    <!-- <h4 class="tabContentHeading" *ngIf="showModal === 'questions'">Questions</h4> -->
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'summary'">Summary</h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'mostUsedWords'">Most Used Words
                                    </h4>
                                    <select (change)="changeTranscriptLgFun()" [(ngModel)]="transcribedLgVariable_T"
                                        name="" id="" class="form-select lg-select-transcript"
                                        *ngIf="showSelect_T && !spinner">
                                        <option *ngFor="let lg of transcribedLg_T" [value]="lg">{{lg}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-4 tab-head search-input-tab-head" *ngIf="showModal != 'dialogue' && showModal != 'summary'">
                                    <input type="search" class="form-control" placeholder="search keywords"
                                        [(ngModel)]="searchText">
                                    <i class="fa-solid fa-magnifying-glass userSearchLens"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Dialogue Contents -->
                    <div class="tab-content">
                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                        <span class="sr-only">Loading...</span>
                        <div class="tab-pane dialogue-pane"
                            [ngClass]="{'active':showModal === 'dialogue','show':showModal === 'dialogue'}"
                            id="nav-dialogue" *ngIf="!spinner">
                            <div class="accordion accordion-flush" id="accordionFlushExample">
                                <div class="accordion-item accordionClass">
                                    <h2 class="accordion-header" id="flush-headingOne">
                                        <button class="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#flush-collapseOne"
                                            aria-expanded="false" aria-controls="flush-collapseOne" #speakerNameAcButton
                                            (click)="toggleAcButton('name')">
                                            Change Speaker Name
                                        </button>
                                    </h2>
                                    <div id="flush-collapseOne" class="accordion-collapse collapse"
                                        aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                        <div class="accordion-body">
                                            <form class="speakerForm" [formGroup]="speakerForm">
                                                <ng-container formArrayName="speakerArrayForm">
                                                    <ng-container
                                                        *ngFor="let lessonForm of speakerArrayForm.controls; index as i">
                                                        <div class="form-group" [formGroupName]="i">
                                                            <div class="form-group speakerFG">
                                                                <div class="row">
                                                                    <div class="col-md-2 offset-md-1">
                                                                        <label
                                                                            class="form-label speakerLabel">{{dialogueList_T[i]?.display_speaker}}</label>
                                                                    </div>
                                                                    <div class="col-md-5">
                                                                        <input type="text" class="form-control"
                                                                            formControlName="speakerControl"
                                                                            placeholder="Enter Speaker Name">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                                <div class="form-group row">
                                                    <div class="col-md-4 offset-md-3">
                                                        <button class="btn btn-light cancelBtn"
                                                            type="reset">Clear</button>
                                                        <button class="btn btn-primary updateBtn" type="submit"
                                                            (click)="updateSpeaker()"
                                                            [disabled]="!speakerForm.dirty">Update</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item accordionClass">
                                    <h2 class="accordion-header" id="flush-headingTwo">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#flush-collapseTwo" aria-expanded="false"
                                            aria-controls="flush-collapseTwo" #conversationAcButton
                                            (click)="toggleAcButton('conversation')">
                                            Conversation
                                        </button>
                                    </h2>
                                    <div id="flush-collapseTwo" class="accordion-collapse collapse show"
                                        aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                        <div class="accordion-body">
                                            <div class="modal-subtitle modal-subtitle2 border-bottom">
                                                <div class="row">
                                                    <div class="col-md-7 tab-head d-flex">
                                                        <div class="headeSection">
                                                            <h4 class="tabContentHeading"
                                                                *ngIf="showModal === 'dialogue' && !showTransOriginal">
                                                                Modified Dialogue</h4>
                                                            <h4 class="tabContentHeading"
                                                                *ngIf="showModal === 'dialogue' && showTransOriginal">
                                                                Original Dialogue</h4>
                                                        </div>
                                                        <select (change)="changeTranscriptLgFun()"
                                                            [(ngModel)]="transcribedLgVariable_T" name="" id=""
                                                            class="form-select lg-select-transcript"
                                                            *ngIf="showSelect_T && !spinner">
                                                            <option *ngFor="let lg of transcribedLg_T" [value]="lg">
                                                                {{lg}}
                                                            </option>
                                                        </select>
                                                        <div class="buttonSection d-flex"
                                                            *ngIf="showModalAudioTag && fileIndex === audioFileIndex">
                                                            <i class="fa fa-play" (click)="playAD('play')"
                                                                *ngIf="!showPlayPause" aria-hidden="true"> <span
                                                                    class="play-text">play</span> </i>
                                                            <i class="fa fa-pause" (click)="playAD('pause')"
                                                                *ngIf="showPlayPause" aria-hidden="true"></i>
                                                            <div class="snippet" data-title="dot-typing"
                                                                *ngIf="showPlayPause">
                                                                <div class="stage">
                                                                    <div class="dot-typing"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-5 tab-head tab-head2 ">
                                                        <span class="form-check form-switch"
                                                            [ngClass]="{'hide-id': userDetails?.email === 'radito7519@ekcsoft.com'}">
                                                            <span *ngIf="!showTransOriginal">
                                                                <input class="form-check-input"
                                                                    [checked]="showTransOriginal"
                                                                    (change)="showOriginalTranscript($event)"
                                                                    type="checkbox" id="flexSwitchCheckDefault"
                                                                    tooltip="Switch to Original Dialogue"
                                                                    [options]="myOptions">
                                                            </span>
                                                            <span *ngIf="showTransOriginal">
                                                                <input class="form-check-input"
                                                                    [checked]="showTransOriginal"
                                                                    (change)="showOriginalTranscript($event)"
                                                                    type="checkbox" id="flexSwitchCheckDefault"
                                                                    tooltip="Switch to Modified Dialogue"
                                                                    [options]="myOptions">
                                                            </span>

                                                        </span>
                                                        <div class="search-input-tab-head">
                                                            <input #searchInputDialog type="search"
                                                                class="form-control searchInput"
                                                                placeholder="search keywords" [(ngModel)]="searchText">
                                                            <i class="fa-solid fa-magnifying-glass userSearchLens"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <form [formGroup]="dialogueScriptForm">
                                                <div class="table-responsive">
                                                    <table class="table">
                                                        <thead class="tblHead">
                                                            <tr>
                                                                <th>Speaker</th>
                                                                <th>Transcript</th>
                                                                <th class="option" *ngIf="!showTransOriginal">Option
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody
                                                            *ngIf="!showTransOriginal && transcribedLgVariable_T === 'English'">
                                                            <tr *ngFor="let dialog of dialogueList_T; index as i;"
                                                                [appHighlightword]="searchText">
                                                                <td class="speakerName">{{dialog.display_speaker}}</td>
                                                                <td
                                                                    *ngIf="(dialogueIndex != i || !showRow) && transcribedLgVariable_T === 'English'">
                                                                    {{dialog.edited_text}}</td>
                                                                <td
                                                                    *ngIf="(dialogueIndex != i || !showRow) && transcribedLgVariable_T !== 'English'">
                                                                    {{dialog.spanish_edited_text}}</td>
                                                                <td *ngIf="showRow && transcribedLgVariable_T === 'English'"
                                                                    class="text-start inputClass">
                                                                    <textarea formControlName="input" name="input"
                                                                        id="input" *ngIf="dialogueIndex === i"
                                                                        type="text" class="form-control"
                                                                        value="{{dialog.edited_text}}"></textarea>
                                                                </td>
                                                                <td *ngIf="showRow && transcribedLgVariable_T !== 'English'"
                                                                    class="text-start inputClass">
                                                                    <textarea formControlName="input" name="input"
                                                                        id="input" *ngIf="dialogueIndex === i"
                                                                        type="text" class="form-control"
                                                                        value="{{dialog.spanish_edited_text}}"></textarea>
                                                                </td>
                                                                <td class="text-center" *ngIf="!showRow">
                                                                    <i class="fa-regular fa-pen-to-square"
                                                                        (click)="getEditingText(i)" tooltip="Edit"
                                                                        [options]="myOptions"></i>
                                                                </td>
                                                                <td *ngIf="showRow" class="text-end btnTd">
                                                                    <button *ngIf="dialogueIndex === i" type="button"
                                                                        class="btn btn-light cancelBtn"
                                                                        (click)="CancelEditedText()">Cancel</button>
                                                                    <button *ngIf="dialogueIndex === i"
                                                                        [disabled]="!dialogueScriptForm.controls['input'].dirty"
                                                                        type="button" class="btn btn-primary updateBtn"
                                                                        (click)="updateAwsTranscriptData()">Update</button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        <tbody
                                                            *ngIf="!showTransOriginal && transcribedLgVariable_T !== 'English'">
                                                            <tr *ngFor="let dialog of dialogueList_T; index as i;"
                                                                [appHighlightword]="searchText">
                                                                <td class="speakerName">{{dialog.display_speaker}}</td>
                                                                <td
                                                                    *ngIf="(dialogueIndex != i || !showRow) && transcribedLgVariable_T === 'English'">
                                                                    {{dialog.edited_text}}</td>
                                                                <td
                                                                    *ngIf="(dialogueIndex != i || !showRow) && transcribedLgVariable_T !== 'English'">
                                                                    {{dialog.spanish_edited_text}}</td>
                                                                <td *ngIf="showRow && transcribedLgVariable_T === 'English'"
                                                                    class="text-start inputClass">
                                                                    <textarea formControlName="input" name="input"
                                                                        id="input" *ngIf="dialogueIndex === i"
                                                                        type="text" class="form-control"
                                                                        value="{{dialog.edited_text}}"></textarea>
                                                                </td>
                                                                <td *ngIf="showRow && transcribedLgVariable_T !== 'English'"
                                                                    class="text-start inputClass">
                                                                    <textarea formControlName="input" name="input"
                                                                        id="input" *ngIf="dialogueIndex === i"
                                                                        type="text" class="form-control"
                                                                        value="{{dialog.spanish_edited_text}}"></textarea>
                                                                </td>
                                                                <td class="text-center" *ngIf="!showRow">
                                                                    <i class="fa-regular fa-pen-to-square"
                                                                        (click)="getEditingText(i)" tooltip="Edit"
                                                                        [options]="myOptions"></i>
                                                                </td>
                                                                <td *ngIf="showRow" class="text-end btnTd">
                                                                    <button *ngIf="dialogueIndex === i" type="button"
                                                                        class="btn btn-light cancelBtn"
                                                                        (click)="CancelEditedText()">Cancel</button>
                                                                    <button *ngIf="dialogueIndex === i"
                                                                        [disabled]="!dialogueScriptForm.controls['input'].dirty"
                                                                        type="button" class="btn btn-primary updateBtn"
                                                                        (click)="updateAwsTranscriptData()">Update</button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        <tbody *ngIf="showTransOriginal">
                                                            <tr *ngFor="let dialog of dialogueList_T; index as i;"
                                                                [appHighlightword]="searchText">
                                                                <td class="speakerName">{{dialog.original_speaker}}</td>
                                                                <td *ngIf="transcribedLgVariable_T === 'English'">
                                                                    {{dialog.oroginal_text}}</td>
                                                                <td *ngIf="transcribedLgVariable_T !== 'English'">
                                                                    {{dialog.spanish_original_text}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Transcript -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'transcript','show':showModal === 'transcript'}"
                            id="nav-transcript" *ngIf="!spinner">

                            @if(transcribedLgVariable_T === 'English'){
                                <div class="transcriptTab">
                                <ul *ngFor="let trans of dialogueList_T;" [appHighlightword]="searchText"
                                    class="ulTranscript">
                                    <li>{{trans.edited_text}}</li>
                                    <!-- <li *ngIf="transcribedLgVariable_T !== 'English' ">{{trans.spanish_edited_text}}</li> -->
                                </ul>
                                <p class="noRecord text-center" *ngIf="!dialogueList_T.length">No records found</p>
                            </div>
                            } @else if(transcribedLgVariable_T === 'Arabic'){
                                <div class="transcriptTab">
                                    <ul *ngFor="let trans of dialogueList_T;" [appHighlightword]="searchText"
                                        class="ulTranscript arabic">
                                        <!-- <li *ngIf="transcribedLgVariable_T === 'English' ">{{trans.edited_text}}</li> -->
                                        <li>{{trans.spanish_edited_text}}</li>
                                    </ul>
                                    <p class="noRecord text-center" *ngIf="!dialogueList_T.length">No records found</p>
                                </div>
                            }@else{
                                <div class="transcriptTab">
                                    <ul *ngFor="let trans of dialogueList_T;" [appHighlightword]="searchText"
                                        class="ulTranscript">
                                        <!-- <li *ngIf="transcribedLgVariable_T === 'English' ">{{trans.edited_text}}</li> -->
                                        <li>{{trans.spanish_edited_text}}</li>
                                    </ul>
                                    <p class="noRecord text-center" *ngIf="!dialogueList_T.length">No records found</p>
                              </div>
                            }
                            <!-- <div class="transcriptTab" *ngIf="transcribedLgVariable_T === 'English' ">
                                <ul *ngFor="let trans of dialogueList_T;" [appHighlightword]="searchText"
                                    class="ulTranscript">
                                    <li *ngIf="transcribedLgVariable_T === 'English' ">{{trans.edited_text}}</li>
                                    <li *ngIf="transcribedLgVariable_T !== 'English' ">{{trans.spanish_edited_text}}
                                    </li>
                                </ul>
                                <p class="noRecord text-center" *ngIf="!dialogueList_T.length">No records found</p>
                            </div>
                            <div class="transcriptTab" *ngIf="transcribedLgVariable_T !== 'English' ">
                                <ul *ngFor="let trans of dialogueList_T;" [appHighlightword]="searchText"
                                    class="ulTranscript">
                                    <li *ngIf="transcribedLgVariable_T === 'English' ">{{trans.edited_text}}</li>
                                    <li *ngIf="transcribedLgVariable_T !== 'English' ">{{trans.spanish_edited_text}}
                                    </li>
                                </ul>
                                <p class="noRecord text-center" *ngIf="!dialogueList_T.length">No records found</p>
                            </div> -->
                        </div>
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'keyword','show':showModal === 'keyword'}"
                            id="nav-keyword" *ngIf="!spinner">
                            <!--Keyword/Phrases-->
                            <div class="keywordTab" *ngIf="transcribedLgVariable_T === 'English' ">
                                <ul *ngFor="let keyword of keywordList_T; index as i;" [appHighlightword]="searchText"
                                    class="border-bottom">
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.matches}} <p *ngIf="keyword.matches.length < 1" class="text-center">No
                                            matches were found for keyword - "{{keyword.keyword}}"</p>
                                    </li>
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_matches}} <p *ngIf="keyword.spanish_matches.length < 1"
                                            class="text-center">No matches were found for keyword -
                                            "{{keyword.spanish_keyword}}"</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="keywordTab" *ngIf="transcribedLgVariable_T !== 'English' ">
                                <ul *ngFor="let keyword of keywordList_T; index as i;" [appHighlightword]="searchText"
                                    class="border-bottom">
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.matches}} <p *ngIf="keyword.matches.length < 1" class="text-center">No
                                            matches were found for keyword - "{{keyword.keyword}}"</p>
                                    </li>
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_matches}} <p *ngIf="keyword.spanish_matches.length < 1"
                                            class="text-center">No matches were found for keyword -
                                            "{{keyword.spanish_keyword}}"</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- AlertKeyword -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'alertKeywords','show':showModal === 'alertKeywords'}"
                            id="nav-alertKeywords" *ngIf="!spinner">
                            <div class="alertkeywordTab" *ngIf="transcribedLgVariable_T === 'English' ">
                                <ul *ngFor="let keyword of alertkeywordList_T ; index as i;" [appHighlightword]="searchText"
                                    class="border-bottom">
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.matches}} <p *ngIf="keyword.matches.length < 1" class="text-center">No
                                            matches were found for keyword -
                                            "{{keyword.keyword}}"</p>
                                    </li>
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_matches}} <p *ngIf="keyword.matches.length < 1"
                                            class="text-center">No matches were found for keyword -
                                            "{{keyword.spanish_keyword}}"</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="alertkeywordTab" *ngIf="transcribedLgVariable_T !== 'English' ">
                                <ul *ngFor="let keyword of alertkeywordList_T ; index as i;" [appHighlightword]="searchText"
                                    class="border-bottom">
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.matches}} <p *ngIf="keyword.matches.length < 1" class="text-center">No
                                            matches were found for keyword -
                                            "{{keyword.keyword}}"</p>
                                    </li>
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_matches}} <p *ngIf="keyword.matches.length < 1"
                                            class="text-center">No matches were found for keyword -
                                            "{{keyword.spanish_keyword}}"</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- question tab -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'questions','show':showModal === 'questions'}"
                            id="nav-questions" *ngIf="!spinner">
                            <div class="questionTab2" *ngIf="englishQuestions_T?.length == 0">
                                <p class="noRecord">No Records Found</p>
                            </div>
                            <div class="questionTab" *ngIf="englishQuestions_T?.length > 0">
                                <table>
                                    <tbody>
                                        <tr *ngFor="let question of englishQuestions_T ; index as i;"
                                            [appHighlightword]="searchText">
                                            <td class="numberTd">{{i+1}}.</td>
                                            @if(transcribedLgVariable_T === 'English'){
                                            <td>
                                                <p class="answerPara">
                                                    <!-- <b>{{"Q:("+question.question_speaker_name+")"}}</b> -->
                                                    {{question.question}}
                                                </p>
                                                <!-- <p> <b>{{"A:("+question.answer_speaker_name+")"}}</b>
                                                    {{question.answer}}</p> -->
                                            </td>
                                            } @else if(transcribedLgVariable_T === 'Arabic'){
                                                <td>
                                                <p class="answerPara">
                                                    <!-- <b>{{"Q:("+question.question_speaker_name+")"}}</b> -->
                                                    <span class="arabic">{{question.spanish_question}}</span>
                                                </p>
                                                <!-- <p> <b>{{"A:("+question.answer_speaker_name+")"}}</b>
                                                 <span class="arabic">    {{question.spanish_answer}} </span>
                                                </p> -->
                                            </td>
                                            } @else{
                                           
                                            <td>
                                                <p class="answerPara">
                                                    <!-- <b>{{"Q:("+question.question_speaker_name+")"}}</b> -->
                                                    {{question.spanish_question}}
                                                </p>
                                                <!-- <p> <b>{{"A:("+question.answer_speaker_name+")"}}</b>
                                                    {{question.spanish_answer}}</p> -->
                                            </td>
                                        }
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- summary tab -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'summary','show':showModal === 'summary'}"
                            id="nav-summary" *ngIf="!spinner">
                            <div class="summaryTab">
                                <p>{{llm_sentiment_summary}}</p>
                                <!-- <p *ngFor="let sum of keywordSummary_T;" [appHighlightword]="searchText">{{sum}}</p>
                                <p class="noRecord text-center" *ngIf="!keywordSummary_T?.length">No records found</p> -->
                            </div>
                        </div>
                        <!-- most used words tab -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'mostUsedWords','show':showModal === 'mostUsedWords'}"
                            id="nav-mostUsedWords" *ngIf="!spinner">
                            <div class="mostUsedWordTab">
                                <p class="data" *ngFor="let word of mostUsedWords_T ; index as i;"
                                    [appHighlightword]="searchText">
                                    {{i+1}}.
                                    {{word.word}}
                                    ({{word.count}})</p>
                                <p class="noRecord text-center" *ngIf="!mostUsedWords_T?.length">No records found</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Call Category Modal Window -->
    <div class="modal fade" id="callCategoryModal" tabindex="-1" aria-labelledby="callCategoryModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="callCategoryModalLabel">Call Category</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearCallCategory()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <div class="card modalCard">
                        <div class="card-header">
                            <p>Call Category Details</p>
                        </div>
                        <div class="card-body">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Category</th>
                                        <th>Keywords</th>
                                        <th>Matched Keywords</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center" *ngIf="call_category.length === 0">
                                        <td colspan="3">
                                            <p class="noRecord">No Records Found</p>
                                    </tr>
                                    <ng-container *ngFor="let call of call_category; index as i">
                                    <tr *ngIf="call.active=='true'">
                                        <td>{{call?.category}}</td>
                                        <td>{{call?.keywords.join(', ')}}</td>
                                        <td>{{call?.matched_keywords.join(', ')}} <p class="text-center"
                                                *ngIf="!call?.matched_keywords">-</p>
                                        </td>
                                    </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Keyword Percentage Modal Window -->
    <div class="modal fade" id="keywordPercentageModal" tabindex="-1" aria-labelledby="keywordPercentageModal"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="keywordPercentageModalLabel">Keyword Details</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearKeywordDetails()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="modal-subtitle border-bottom">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-8 tab-head">
                                    <h4 class="tabContentHeading" *ngIf="!spinner">Keyword/Phrases
                                        {{"( "+ (transcriptModalData.keywords_percentage |
                                        number:'1.0-1')+"% )" }}</h4>
                                    <select (change)="changeTranscriptLgFun()" [(ngModel)]="transcribedLgVariable"
                                        name="" id="" class="form-select lg-select-transcript"
                                        *ngIf="showSelect && !spinner">
                                        <option *ngFor="let lg of transcribedLg" [value]="lg">{{lg}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-4 tab-head search-input-tab-head">
                                    <input type="search" class="form-control" placeholder="search keywords"
                                        [(ngModel)]="searchText">
                                    <i class="fa-solid fa-magnifying-glass userSearchLens"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane" id="nav-keyword" *ngIf="!spinner">
                        <!--Keyword/Phrases-->
                        <div class="keywordTab">
                            <ul *ngFor="let keyword of keywordList | search: searchText; index as i">
                                <li class="keywordLi" *ngIf="transcribedLgVariable === 'English' ">
                                    {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                <li class="matchesLi" *ngIf="transcribedLgVariable === 'English' ">
                                    {{keyword.matches}} <p *ngIf="keyword.matches.length < 1" class="text-center">No
                                        matches were found for keyword - "{{keyword.keyword}}"</p>
                                </li>
                                <li class="keywordLi" *ngIf="transcribedLgVariable !== 'English' ">
                                    {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                <li class="matchesLi" *ngIf="transcribedLgVariable !== 'English' ">
                                    {{keyword.spanish_matches}} <p *ngIf="keyword.spanish_matches.length < 1"
                                        class="text-center">No matches were found for keyword -
                                        "{{keyword.spanish_keyword}}"</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- QA Metrics Modal Window -->
    <div class="modal fade" id="qaMetricsModal" tabindex="-1" aria-labelledby="qaMetricsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-xl"  [ngClass]="{'full-screen':metricFullscreen}">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="qaMetricsModalLabel">Metric Details</h4>
                    <span>
                    <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
                    <i class="fa-solid fa-xmark exitIcon " data-bs-dismiss="modal" aria-label="Close"
                        (click)="clearMetricsModalData()"></i>
                    </span>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="card modalCard">
                        <div class="card-header">
                            <p>Metric Details (Agent QA Score - {{QAMetricsData?.qa_metrics?.metric_score |
                                number:'1.0-1'}})</p>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th colspan="6" class="text-center">Machine Scores based on QA Metric</th>
                                            <th colspan="2" class="text-center">Manual Score</th>
                                        </tr>
                                        <tr>
                                            <th>Configured QA Parameter</th>
                                            <th>Configured <br>QA Score</th>
                                            <th>Configured Keywords</th>
                                            <th>Machine Score <br>for Agent</th>
                                            <!-- <th>Weightage (%)</th> -->
                                            <th>Matched keywords from call transcript</th>
                                            <th>QA Analyst <br>Manual Score</th>
                                            <th colspan="2">QA Analyst Manual Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="text-center" *ngIf="metricsMatches.length === 0 && !spinner">
                                            <td colspan="8">
                                                <p class="noRecord">No Records Found</p>
                                        </tr>
                                        <tr *ngIf="metricsMatches.length">
                                            <td></td>
                                            <td>{{QAMetricsData.qa_metrics?.total_score}}</td>
                                            <td></td>
                                            <td>{{QAMetricsData.qa_metrics?.agent_total | number : '1.0-1'}}</td>
                                            <td></td>
                                            <td>{{metricsTotal}}</td>
                                            <td colspan="2"></td>
                                           
                                        </tr>
                                        <tr *ngFor="let call of metricsMatches; index as i"
                                            [ngClass]="{'agent-score-background-color':call?.agent_score > 1}">
                                            <td *ngIf="call?.active === 'true'">{{call?.category}}</td>
                                            <td style="text-align: center;" *ngIf="call?.active === 'true'">{{call?.score}}</td>
                                            <td *ngIf="call?.active === 'true'" appReadMore [toggle]="true" [limit]="55" >{{call?.keywords}}</td>
                                            <td style="text-align: center;" *ngIf="call?.active === 'true'">{{validate_numeric_agent_score(call?.agent_score)}}
                                            </td>
                                            <!-- <td style="text-align: center;" *ngIf="call?.active === 'true'">{{call?.matched_percentage | number
                                                :'1.0-1'}}%</td> -->
                                            <td *ngIf="call?.active === 'true'" >{{call?.matched_keywords}}
                                                <p class="text-center" *ngIf="!call?.matched_keywords">-</p>
                                            </td>
                                            <td (click)="showManualField(i)"
                                                *ngIf="i !== getMetricsIndex && call?.active === 'true'">
                                                <i class="fa-regular fa-pen-to-square"></i>
                                                <!-- {{metricsMScore ? metricsMScore : call?.manual_score}} -->
                                                <p class="text-center" *ngIf="metricsTotalScoreArray[i]">{{metricsTotalScoreArray[i]}}</p>
                                                <p class="text-center" *ngIf="metricsTotalScoreArray[i]==''">-
                                                </p>
                                            </td>
                                            <td *ngIf="i === getMetricsIndex && call?.active === 'true'">
                                                <input type="text" #restrictScore [(ngModel)]="metricsMScore"
                                                      class="form-control" max="{{call?.score}}"
                                                    (keyup)="sendMetricIndex(i, 'score')">
                                                    <!-- <div *ngIf="metricsMScore">
                                                        <span class="error" style="color:red;" *ngIf="metricsMScore > call?.score">Value should not greater than to Configured QA Score</span>
                                                    </div> -->
                                                     
                                            </td>
                                            <td colspan="2" (click)="showManualField(i)"
                                                *ngIf="i !== getMetricsIndex && call?.active === 'true'">
                                                <i class="fa-regular fa-pen-to-square"></i>
                                                <p *ngIf="metricsCommentsArray[i]">{{metricsCommentsArray[i]}}</p>
                                                <div *ngIf="!metricsMComments_valid && metricsCommentsArray[i]">
                                                        <span class="error" style="color:red;">Enter valid comments</span>
                                                    </div>
                                                <p class="text-center" *ngIf="!metricsCommentsArray[i]">-
                                                </p>
                                            </td>
                                            <td colspan="2" *ngIf="i === getMetricsIndex && call?.active === 'true'">
                                                <textarea type="text" [(ngModel)]="metricsMComments"
                                                    class="form-control"
                                                    (change)="sendMetricIndex(i, 'comment')"></textarea>
                                                   
                                            </td>
                                        </tr>
                                        <tr *ngIf="metricsMatches.length">
                                            <td><b>Total Scores</b></td>
                                            <td>{{QAMetricsData.qa_metrics?.total_score}}</td>
                                            <td></td>
                                            <td>{{QAMetricsData.qa_metrics?.agent_total | number : '1.0-1'}}</td>
                                            <td></td>
                                           
                                            <td>{{metricsTotal}}</td>
                                            <td colspan="2"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light cancelBtn" data-bs-dismiss="modal"
                        (click)="clearMetricsModalData()">Cancel</button>
                    <button type="button" class="btn btn-primary updateBtn" (click)="updateMetricsManualField()"
                        [disabled]="!showManualInput && !metricsMComments_valid" 
                         >Update</button>
                </div>
            </div>
        </div>
    </div>
     <!--Mandatory Regulatory QA Metrics Modal Window -->
     <div class="modal fade" id="MandatoryRegulatoryModal" tabindex="-1" aria-labelledby="qaMetricsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-xl"  [ngClass]="{'full-screen':metricFullscreen}">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="qaMetricsModalLabel">Metric Details</h4>
                    <span>
                    <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
                    <i class="fa-solid fa-xmark exitIcon " data-bs-dismiss="modal" aria-label="Close"
                        (click)="clearMetricsModalData()"></i>
                    </span>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="card modalCard">
                        <div class="card-header">
                            <p>Metric Details (Agent QA Score - {{QAMetricsData?.qa_metrics?.llm_total_score |
                                number:'1.0-1'}})</p>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th colspan="6" class="text-center">Machine Scores based on QA Metric</th>
                                            <th colspan="2" class="text-center">Manual Score</th>
                                        </tr>
                                        <tr>
                                            <th>Configured QA Parameter</th>
                                            <th>Configured <br>QA Score</th>
                                            <th>Configured Keywords</th>
                                            <th>Machine Score <br>for Agent</th>
                                            <!-- <th>Weightage (%)</th> -->
                                            <th>Matched keywords from call transcript</th>
                                            <th>QA Analyst <br>Manual Score</th>
                                            <th colspan="2">QA Analyst Manual Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="text-center" *ngIf="metricsMatches.length === 0 && !spinner">
                                            <td colspan="8">
                                                <p class="noRecord">No Records Found</p>
                                        </tr>
                                        <tr *ngIf="metricsMatches.length">
                                            <td></td>
                                            <td>{{QAMetricsData.qa_metrics?.llm_configured_score}}</td>
                                            <td></td>
                                            <td>{{QAMetricsData.qa_metrics?.llm_total_score | number : '1.0-1'}}</td>
                                            <td></td>
                                            <td>{{metricsTotal}}</td>
                                            <td colspan="2"></td>
                                           
                                        </tr>
                                        <tr *ngFor="let call of metricsMatches; index as i"
                                            [ngClass]="{'agent-score-background-color':call?.agent_score > 1}">
                                            <td *ngIf="call?.active === 'true'">{{call?.category}}</td>
                                            <td style="text-align: center;" *ngIf="call?.active === 'true'">{{call?.score}}</td>
                                            <td *ngIf="call?.active === 'true'" appReadMore [toggle]="true" [limit]="55" >{{call?.keywords}}</td>
                                            <td style="text-align: center;" *ngIf="call?.active === 'true'">{{validate_numeric_agent_score(call?.mandatory_score)}}
                                            </td>
                                            <!-- <td style="text-align: center;" *ngIf="call?.active === 'true'">{{call?.matched_percentage | number
                                                :'1.0-1'}}%</td> -->
                                            <td *ngIf="call?.active === 'true'" >{{call?.matched_keywords}}
                                                <p class="text-center" *ngIf="!call?.matched_keywords">-</p>
                                            </td>
                                            <td (click)="showManualField(i)"
                                                *ngIf="i !== getMetricsIndex && call?.active === 'true'">
                                                <i class="fa-regular fa-pen-to-square"></i>
                                                <!-- {{metricsMScore ? metricsMScore : call?.manual_score}} -->
                                                <p class="text-center" *ngIf="metricsTotalScoreArray[i]">{{metricsTotalScoreArray[i]}}</p>
                                                <p class="text-center" *ngIf="metricsTotalScoreArray[i]==''">-
                                                </p>
                                            </td>
                                            <td *ngIf="i === getMetricsIndex && call?.active === 'true'">
                                                <input type="text" #restrictScore [(ngModel)]="metricsMScore"
                                                      class="form-control" max="{{call?.score}}"
                                                    (keyup)="sendMetricIndex(i, 'score')">
                                                    <div *ngIf="metricsMScore">
                                                        <span class="error" style="color: red;" *ngIf="!metricsMScore_valid">Enter valid data</span>
                                                        <span class="error" style="color:red;" *ngIf="metricsMScore > call?.score">Value should not greater than to Configured QA Score</span>
                                                    </div>
                                                     
                                            </td>
                                            <td colspan="2" (click)="showManualField(i)"
                                                *ngIf="i !== getMetricsIndex && call?.active === 'true'">
                                                <i class="fa-regular fa-pen-to-square"></i>
                                                <p *ngIf="metricsCommentsArray[i]">{{metricsCommentsArray[i]}}</p>
                                                 <div *ngIf="!metricsMComments_valid && metricsCommentsArray[i]">
                                                        <span class="error" style="color:red;">Enter valid comments</span>
                                                    </div>
                                                <p class="text-center" *ngIf="!metricsCommentsArray[i]">-
                                                </p>
                                            </td>
                                            <td colspan="2" *ngIf="i === getMetricsIndex && call?.active === 'true'">
                                                <textarea type="text" [(ngModel)]="metricsMComments"
                                                    class="form-control"
                                                    (change)="sendMetricIndex(i, 'comment')"></textarea>
                                                   
                                            </td>
                                        </tr>
                                        <tr *ngIf="metricsMatches.length">
                                            <td><b>Total Scores</b></td>
                                            <td>{{QAMetricsData.qa_metrics?.llm_configured_score}}</td>
                                            <td></td>
                                            <td>{{QAMetricsData.qa_metrics?.llm_total_score | number : '1.0-1'}}</td>
                                            <td></td>
                                           
                                            <td>{{metricsTotal}}</td>
                                            <td colspan="2"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light cancelBtn" data-bs-dismiss="modal"
                        (click)="clearMetricsModalData()">Cancel</button>
                    <button type="button" class="btn btn-primary updateBtn" (click)="updateMandatoryMetricsManualField()"
                        [disabled]="!showManualInput && !metricsMComments_valid" 
                         >Update</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modulation Modal Window -->
    <div class="modal fade" id="modulationModal" tabindex="-1" aria-labelledby="modulationModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="modulationModalLabel">Modulation Details</h4>
                    <i class="fa-solid fa-xmark exitIcon " data-bs-dismiss="modal" aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <div class="card modalCard">
                        <div class="card-header">
                            <p>Modulation Details (Modulation Percentage - {{tableData[callCategoryIndex]?.pause_score |
                                number:'1.0-0'}}%)</p>
                        </div>
                        <div class="card-body">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th colspan="2">Negative Modulation</th>
                                    </tr>
                                    <tr>
                                        <th>Word</th>
                                        <th>Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center" *ngIf="modulationData?.negative?.length === 0">
                                        <td colspan="3">
                                            <p class="noRecord">No Records Found</p>
                                    </tr>
                                    <tr *ngFor="let call of modulationData?.negative; index as i">
                                        <td>{{call?.word}}</td>
                                        <td>{{call?.score | number:'1.0-0'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th colspan="2">Positive Modulation</th>
                                    </tr>
                                    <tr>
                                        <th>Word</th>
                                        <th>Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center" *ngIf="modulationData?.positive?.length === 0">
                                        <td colspan="3">
                                            <p class="noRecord">No Records Found</p>
                                    </tr>
                                    <tr *ngFor="let call of modulationData?.positive; index as i">
                                        <td>{{call?.word}}</td>
                                        <td>{{call?.score | number:'1.0-0'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Record Info Edit Modal Window -->
    <div class="modal fade" id="RecordDeleteModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="RecordDeleteModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="RecordDeleteModalLabel">Voice Details</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearRecordData()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="infoHeading d-flex border-bottom">
                        <p class="infoFirst"> <b>Details</b></p>
                        <button class="btn infoSecond" (click)="editInfoDetails()">
                            <i *ngIf="!infoEditShow" class="fa-regular fa-pen-to-square" tooltip="Edit Info"
                                [options]="myOptions"></i>
                            <i *ngIf="infoEditShow" class="fa fa-arrow-left" aria-hidden="true" tooltip="Back"
                                [options]="myOptions"></i>
                        </button>
                    </div>
                    <form [formGroup]="infoForm">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel"><b>Display Name</b><i
                                                class="fa-solid fa-asterisk mandatoryIcon"
                                                *ngIf="infoEditShow"></i></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">{{infoDetails?.display_file_name}}</p>
                                    <input *ngIf="infoEditShow" formControlName="display_file_name"
                                        name="display_file_name" id="display_file_name" type="text"
                                        class="form-control">
                                    <span class="text-danger"
                                        *ngIf="infoForm.controls['display_file_name'].invalid && infoForm.controls['display_file_name'].dirty && infoForm.hasError('required','display_file_name')">
                                        Display name is Required.
                                    </span>
                                     <span class="text-danger"
                                        *ngIf="infoForm.controls['display_file_name'].touched && infoForm.controls['display_file_name'].dirty && infoForm.hasError('pattern','display_file_name')">
                                        Enter valid display name.
                                    </span>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel"><b>Customer</b><i
                                                class="fa-solid fa-asterisk mandatoryIcon"
                                                *ngIf="infoEditShow"></i></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">{{infoDetails?.caller_name}}</p>
                                    <input *ngIf="infoEditShow" formControlName="caller_name" name="caller_name"
                                        id="caller_name" type="text" class="form-control"
                                        placeholder="Enter the queue name">
                                    <span class="text-danger"
                                        *ngIf="infoForm.controls['caller_name'].invalid && infoForm.controls['caller_name'].dirty && infoForm.hasError('required','caller_name')">
                                        Customer name is Required.
                                    </span>
                                    <span class="text-danger"
                                        *ngIf="infoForm.controls['caller_name'].touched && infoForm.controls['caller_name'].dirty && infoForm.hasError('pattern','caller_name')">
                                       Enter valid Customer name.
                                    </span>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel"><b>Agent</b><i
                                                class="fa-solid fa-asterisk mandatoryIcon"
                                                *ngIf="infoEditShow"></i></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">{{infoDetails?.agent_name}}</p>
                                    <input *ngIf="infoEditShow" [attr.disabled]="true" formControlName="agent_name"
                                        name="agent_name" id="agent_name" type="text" class="form-control"
                                        placeholder="Enter the queue name">
                                    <span class="text-danger"
                                        *ngIf="infoForm.controls['agent_name'].invalid && infoForm.controls['agent_name'].dirty && infoForm.hasError('required','agent_name')">
                                        Agent name is Required.
                                    </span>
                                    <span class="text-danger"
                                        *ngIf="infoForm.controls['agent_name'].touched && infoForm.controls['agent_name'].dirty && infoForm.hasError('pattern','agent_name')">
                                        Enter valid Agent name.
                                    </span>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Topics</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">{{infoTopicsName}}</p>

                                    <ng-select *ngIf="infoEditShow" formControlName="topic" dropdownPosition="auto"
                                        name="topic" id="topic" placeholder="Choose/Search topic" [clearable]="false">
                                        <ng-option [value]="info.id?.$oid" title="{{info?.id?.$oid}}"
                                            *ngFor="let info of getInfoTopics; index as i">{{info?.topic}}</ng-option>
                                    </ng-select>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Your Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.own_key_words">{{infoDetails?.own_key_words}}</span>
                                        <span *ngIf="!infoDetails?.own_key_words?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="own_key_words"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="own_key_words"
                                        name="own_key_words" autocomplete="off" [disable]="disableInput"
                                        [addOnPaste]="true" [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'own_key_words')"></tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Alert Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.alert_keywords">{{infoDetails?.alert_keywords}}</span>
                                        <span *ngIf="!infoDetails?.alert_keywords?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="alert_keywords"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="alert_keywords"
                                        name="alert_keywords" autocomplete="off" [disable]="disableInput"
                                        [addOnPaste]="true" [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'alert_keywords')"></tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Sensitive Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span
                                            *ngIf="infoDetails?.sensitive_words">{{infoDetails?.sensitive_words}}</span>
                                        <span *ngIf="!infoDetails?.sensitive_words?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="sensitive_words"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal"
                                        id="sensitive_words" name="sensitive_words" autocomplete="off"
                                        [disable]="disableInput" [addOnPaste]="true" [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'sensitive_words')">
                                    </tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Hide Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.hide_keywords">{{infoDetails?.hide_keywords}}</span>
                                        <span *ngIf="!infoDetails?.hide_keywords?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="hide_keywords"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="hide_keywords"
                                        name="hide_keywords" autocomplete="off" [disable]="disableInput"
                                        [addOnPaste]="true" [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'hide_keywords')"></tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Delete Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.delete_words">{{infoDetails?.delete_words}}</span>
                                        <span *ngIf="!infoDetails?.delete_words?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="delete_words"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="delete_words"
                                        name="delete_words" autocomplete="off" [disable]="disableInput"
                                        [addOnPaste]="true" [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'delete_words')"></tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Comments</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.conversation">{{infoDetails?.conversation}}</span>
                                        <span *ngIf="!infoDetails?.conversation"><b>-</b></span>
                                    </p>
                                    <textarea *ngIf="infoEditShow" formControlName="conversation" type="text"
                                        class="form-control" placeholder="Enter all audit comment"></textarea>
                                         <span class="text-danger"
                                        *ngIf="infoForm.controls['conversation'].touched && infoForm.controls['conversation'].dirty && infoForm.hasError('pattern','conversation')">
                                        Enter valid Agent name.
                                    </span>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Language</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection language-form-group">
                                    <p class="infoData" *ngIf="!infoEditShow">{{infoDetailsLanguage}}</p>
                                    <ng-select *ngIf="infoEditShow" [attr.disabled]="true" [readonly]="true"
                                        formControlName="language" type='text' placeholder="Choose Language">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" *ngIf="infoEditShow" (click)="clearRecordData()"
                        class="btn btn-light cancelBtn" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" [disabled]="!infoForm.dirty || infoForm.invalid" *ngIf="infoEditShow"
                        class="btn btn-primary updateBtn" (click)="updateInfoDetails()" data-bs-dismiss="modal"
                        >Update</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Report Modal -->
    <div class="modal fade reportModalClass" #reportModalContent data-bs-backdrop="static" data-bs-keyboard="false"
        id="reportModal" tabindex="-1" aria-labelledby="reportModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="reportModalLabel">Recorded Call Analysis Report</h4>
                    <i class="fa-solid fa-xmark exitIcon " #exitReport (click)="clearKeywordDetails()"
                        data-bs-dismiss="modal" aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="container-fluid">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="reportFirstPart d-flex language-form-group">
                                        <select (change)="changeTranscriptLgReport()"
                                            [(ngModel)]="transcribedLgVariable" name="" id=""
                                            class="form-select lg-select-transcript"
                                            *ngIf="showSelect && !downloadSpinner">
                                            <option *ngFor="let lg of transcribedLg" [value]="lg">{{lg}}
                                            </option>
                                        </select>
                                        <button class="btn updateBtn" (click)="makePDF()"
                                            [disabled]="downloadBtnSpinner">
                                            <i *ngIf="downloadBtnSpinner"
                                                class="fa fa-spinner fa-pulse fa-3x fa-fw download-spinner"></i>
                                            <span class="sr-only">Loading...</span> Download Report</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row reportSecondPart">
                            <div class="col-md-8 offset-md-3">
                                <table id="report-top-details" class="reportTable" style="display: none;">
                                    <thead style="display: none;">
                                        <tr>
                                            <th colspan="4">Report Details - {{dateTime | date:'shortDate'}} </th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td> <label class="form-label first-label"><b>File Uploaded Date
                                                    </b></label> </td>
                                            <td> <span class="form-detail"> {{infoDetails?.time_stamp |
                                                    date:'shortDate'}}</span> </td>
                                            <td> <label class="form-label second-label"><b>Call Queue/Topic
                                                    </b></label> </td>
                                            <td> <span> {{infoDetails?.display_file_name}}</span> </td>
                                        </tr>
                                        <tr>
                                            <td> <label class="form-label first-label"><b>Customer </b></label> </td>
                                            <td> <span> {{infoDetails?.caller_name}}</span> </td>
                                            <td> <label class="form-label second-label"><b>Agent Name </b></label>
                                            </td>
                                            <td> <span> {{infoDetails?.agent_name}}</span> </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="row">
                                    <div class="col-md-5">
                                        <label class="form-label"><b>File Uploaded Date : </b></label>
                                        <span> {{infoDetails?.time_stamp | date:'shortDate'}}</span>
                                    </div>
                                    <div class="col-md-5">
                                        <label class="form-label"><b>Call Queue/Topic : </b></label>
                                        <span> {{infoDetails?.display_file_name}}</span>
                                    </div>
                                    <div class="col-md-5">
                                        <label class="form-label"><b>Customer : </b></label>
                                        <span> {{infoDetails?.caller_name}}</span>
                                    </div>
                                    <div class="col-md-5">
                                        <label class="form-label"><b>Agent Name : </b></label>
                                        <span> {{infoDetails?.agent_name}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- sss -->
                        <div class="col-md-6 offset-md-3">
                            <div class="card modalCard2" id="sentimentCard2" style="display:none">
                                <div class="card-header">
                                    <p class="sentiment-header"> Sentiment</p>
                                </div>
                                <table id="sentiment-table-report">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="card-body">
                                                    <ul class="list-group list-group-horizontal">
                                                        <li class="list-group-item secondList">
                                                            <i id="fa-face-smile" class="fa-regular fa-face-smile"></i>
                                                            <p class="sentiment-score">
                                                                {{infoDetails?.positive_sentiment |
                                                                number:'1.0-1'}}%</p>
                                                            <p class="sentiment-name">Positive</p>
                                                        </li>
                                                        <li class="list-group-item secondList">
                                                            <i id="fa-face-meh" class="fa-regular fa-face-meh"></i>
                                                            <p class="sentiment-score">
                                                                {{infoDetails?.neutral_sentiment |
                                                                number:'1.0-1'}}%</p>
                                                            <p class="sentiment-name">Neutral</p>
                                                        </li>
                                                        <li class="list-group-item secondList">
                                                            <i id="fa-face-frown" class="fa-regular fa-face-frown"></i>
                                                            <p class="sentiment-score">
                                                                {{infoDetails?.negative_sentiment |
                                                                number:'1.0-1'}}%</p>
                                                            <p class="sentiment-name">Negative</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!--  -->
                        <div class="row reportThirdPart">
                            <div class="col-md-6 offset-md-3">
                                <!--  -->

                                <!--  -->
                                <div class="card modalCard" id="sentimentCard">
                                    <div class="card-header">
                                        <p class="sentiment-header"> Sentiment</p>
                                    </div>

                                    <div class="card-body">
                                        <ul class="list-group list-group-horizontal">
                                            <li class="list-group-item">
                                                <i id="fa-face-smile" class="fa-regular fa-face-smile"></i>
                                                <p class="sentiment-score">
                                                    {{infoDetails?.positive_sentiment |
                                                    number:'1.0-1'}}%</p>
                                                <p class="sentiment-name">Positive</p>
                                            </li>
                                            <li class="list-group-item">
                                                <i id="fa-face-meh" class="fa-regular fa-face-meh"></i>
                                                <p class="sentiment-score">
                                                    {{infoDetails?.neutral_sentiment |
                                                    number:'1.0-1'}}%</p>
                                                <p class="sentiment-name">Neutral</p>
                                            </li>
                                            <li class="list-group-item">
                                                <i id="fa-face-frown" class="fa-regular fa-face-frown"></i>
                                                <p class="sentiment-score">
                                                    {{infoDetails?.negative_sentiment |
                                                    number:'1.0-1'}}%</p>
                                                <p class="sentiment-name">Negative</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row reportFourthPart">
                            <div class="col-md-6">
                                <div class="card modalCard">
                                    <div class="card-header">
                                        Transcript
                                    </div>
                                    <div class="card-body">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <div class="transcriptTab">
                                            <ul *ngFor="let trans of dialogueList | search: searchText"
                                                class="ulTranscript">
                                                <li *ngIf="transcribedLgVariable === 'English' ">{{trans.edited_text}}
                                                </li>
                                                <li *ngIf="transcribedLgVariable !== 'English' ">
                                                    {{trans.spanish_edited_text}}</li>
                                            </ul>
                                            <p class="noRecord text-center" *ngIf="!dialogueList.length">No records
                                                found</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card modalCard dialogue-text-record-report">
                                    <div class="card-header">
                                        Dialogue
                                    </div>
                                    <div class="card-body">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <table class="table" id="transcriptReport" *ngIf="dialogueList.length">
                                            <thead class="tblHead">
                                                <tr>
                                                    <th>Speaker</th>
                                                    <th>Transcript</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let dialog of dialogueList | search: searchText; index as i">
                                                    <td class="speakerName">{{dialog.display_speaker}}</td>
                                                    <td *ngIf="transcribedLgVariable === 'English' ">
                                                        {{dialog.edited_text}}</td>
                                                    <td *ngIf="transcribedLgVariable !== 'English' ">
                                                        {{dialog.spanish_edited_text}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <!--  -->
                                        <table class="table" id="transcriptReport" *ngIf="!dialogueList.length">
                                            <thead class="tblHead" style="display: none;">
                                                <tr>
                                                    <th>Dialogue</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <p class="noRecord text-center">No Records Found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card modalCard">
                                    <div class="card-header">
                                        Keywords/Phrases
                                    </div>
                                    <div class="card-body keywordTabCardBody">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <table class="keywordTab" id="keyword-phrases-table-report"
                                            *ngIf="keywordList.length > 0">
                                            <tbody>
                                                <tr
                                                    *ngFor="let keyword of keywordList | search: searchText; index as i">
                                                    <td>
                                                        <li class="keywordLi"
                                                            *ngIf="transcribedLgVariable === 'English' ">
                                                            {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                                        <li class="matchesLi"
                                                            *ngIf="transcribedLgVariable === 'English' ">
                                                            <p> {{keyword.matches}}</p>
                                                            <p *ngIf="keyword.matches.length < 1" class="text-center">
                                                                No
                                                                matches were found for keyword -
                                                                "{{keyword.keyword}}"</p>
                                                        </li>
                                                        <li class="keywordLi"
                                                            *ngIf="transcribedLgVariable !== 'English' ">
                                                            {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                                        <li class="matchesLi"
                                                            *ngIf="transcribedLgVariable !== 'English' ">
                                                            <p> {{keyword.spanish_matches}} </p>
                                                            <p *ngIf="keyword.spanish_matches.length < 1"
                                                                class="text-center">
                                                                No
                                                                matches were found for keyword -
                                                                "{{keyword.spanish_keyword}}"</p>
                                                        </li>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="questionTab2" *ngIf="keywordList.length == 0">
                                            <p class="noRecord text-center">No Records Found</p>
                                            <table id="keyword-phrases-table-report" style="display: none;">
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">
                                                            <p class="noRecord">No Records Found</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card modalCard">
                                    <div class="card-header">
                                        Question/Answer
                                    </div>
                                    <div class="card-body">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <div class="questionTab" *ngIf="englishQuestions?.length > 0">
                                            <table id="question-answer-report">
                                                <thead style="display: none;">
                                                    <tr>
                                                        <td colspan="2">Question/Answer</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        *ngFor="let question of englishQuestions | search: searchText; index as i">
                                                        <td class="numberTd">{{i+1}}.</td>
                                                        <td *ngIf="transcribedLgVariable === 'English' ">
                                                            <p class="answerPara">
                                                                <b>{{"Q:("+question.question_speaker_name+")"}}</b>
                                                                {{question.question}}
                                                            </p>
                                                            <p> <b>{{"A:("+question.answer_speaker_name+")"}}</b>
                                                                {{question.answer}}</p>
                                                        </td>
                                                        <td *ngIf="transcribedLgVariable !== 'English' ">
                                                            <p class="answerPara">
                                                                <b>{{"Q:("+question.question_speaker_name+")"}}</b>
                                                                {{question.spanish_question}}
                                                            </p>
                                                            <p> <b>{{"A:("+question.answer_speaker_name+")"}}</b>
                                                                {{question.spanish_answer}}</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="questionTab2" *ngIf="englishQuestions?.length == 0">
                                            <p class="noRecord text-center">No Records Found</p>
                                            <table id="question-answer-report" style="display: none;">
                                                <thead>
                                                    <tr>
                                                        <td colspan="2">Question/Answer</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">
                                                            <p class="noRecord">No Records Found</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card modalCard">
                                    <div class="card-header">
                                        Summary
                                    </div>
                                    <div class="card-body">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <div class="summaryTab">
                                            <p *ngFor="let sum of keywordSummary | search: searchText">{{sum}}</p>
                                            <p class="noRecord text-center" *ngIf="!keywordSummary.length">No Data</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card modalCard">
                                    <div class="card-header">
                                        Most Used Words
                                    </div>
                                    <div class="card-body">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <div class="mostUsedWordTab" *ngIf="mostUsedWords.length > 0">
                                            <table id="most-used-words-table-report">
                                                <tbody>
                                                    <tr
                                                        *ngFor="let word of mostUsedWords | search: searchText; index as i">
                                                        <td>
                                                            <p class="data">
                                                                {{i+1}}.
                                                                {{word.word}}
                                                                ({{word.count}})</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div class="questionTab2" *ngIf="mostUsedWords.length === 0">
                                                <p class="noRecord text-center">No Records Found</p>
                                                <table id="most-used-words-table-report" style="display: none;">
                                                    <tbody>
                                                        <tr>
                                                            <td colspan="2">
                                                                <p class="noRecord">No Records Found</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Sentiment Modal  -->
    <div class="modal fade" id="sentimentModal">
        <div class="modal-dialog modal-dialog-scrollable modal-lg sentimentModalWindow">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"><img src="../../../../assets/images/notes_ai_icon.svg" width="24" height="24">&nbsp; AI Generated Sentiment Summary</h4>
                    <i class="fa-solid fa-xmark exitIcon" (click)="clearSentimentData()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
          
                    <div class="tab-content">
                     
                        <!-- customer tab -->
                        <div class="tab-pane active show" id="customerSentiment">
                      
                           <div class="col-12 px-3 py-3">
                            <div class="position-relative">
                                <div class="sentimentIcon">
                                <i class="fa-regular fa-face-meh audioIcons iconMeh" *ngIf="sentimentRawData.sentiments_icon=='neutral'" ></i>
                                <i class="fa-regular fa-face-smile audioIcons iconSmile" *ngIf="sentimentRawData.sentiments_icon=='positive'" ></i>
                                <i class="fa-regular fa-face-frown audioIcons iconSad" *ngIf="sentimentRawData.sentiments_icon=='negative'"></i>
                                </div>
                            </div>
                            <div class="transcriptTab">
                                <p [innerHTML]="sentimentRawData.sentiment_text | replaceLineBreaks"></p>
                            </div>
                       </div>
                             
                         
                        </div>
                   
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- for pdf printing purpose -->
    <div class="col-md-6 offset-md-3">
        <div class="container" id="sentimentCard55">
            <div class="card modalCard2" id="sentimentCard3" style="display: none;">
                <div class="card-header">
                    <p class="sentiment-header"> Sentiment</p>
                </div>
                <table id="sentiment-table-report">
                    <tbody>
                        <tr>
                            <td>
                                <div class="card-body">
                                    <ul class="list-group list-group-horizontal">
                                        <li class="list-group-item secondList">
                                            <i id="fa-face-smile" class="fa-regular fa-face-smile"></i>
                                            <p class="sentiment-score">
                                                {{infoDetails?.positive_sentiment |
                                                number:'1.0-1'}}%</p>
                                            <p class="sentiment-name">Positive</p>
                                        </li>
                                        <li class="list-group-item secondList">
                                            <i id="fa-face-meh" class="fa-regular fa-face-meh"></i>
                                            <p class="sentiment-score">
                                                {{infoDetails?.neutral_sentiment |
                                                number:'1.0-1'}}%</p>
                                            <p class="sentiment-name">Neutral</p>
                                        </li>
                                        <li class="list-group-item secondList">
                                            <i id="fa-face-frown" class="fa-regular fa-face-frown"></i>
                                            <p class="sentiment-score">
                                                {{infoDetails?.negative_sentiment |
                                                number:'1.0-1'}}%</p>
                                            <p class="sentiment-name">Negative</p>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- two -->
            <div class="col-md-10">
                <div class="dialogue-text-record-report2">
                    <table class="table" id="transcriptReport2" *ngIf="dialogueList.length" style="display: none;">
                        <thead class="tblHead">
                            <tr>
                                <th>Speaker</th>
                                <th>Transcript</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dialog of dialogueList | search: searchText; index as i">
                                <td class="speakerName">{{dialog.display_speaker}}</td>
                                <td *ngIf="transcribedLgVariable === 'English' ">
                                    {{dialog.edited_text}}</td>
                                <td *ngIf="transcribedLgVariable !== 'English' ">
                                    {{dialog.spanish_edited_text}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <!--  -->
                    <table class="table" id="transcriptReport2" *ngIf="!dialogueList.length" style="display: none;">
                        <thead class="tblHead" style="display: none;">
                            <tr>
                                <th>Dialogue</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <p class="noRecord text-center">No Records Found</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <!-- Email Modal Window -->
    <div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="emailModal" tabindex="-1"
        aria-labelledby="emailModalModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg emailModal">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="emailModalModalLabel">Email</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearEmailData()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <div class="card modalCard">
                        <div class="card-header">
                            <p>Email Details</p>
                        </div>
                        <div class="card-body">
                            <div class="container-fluid">
                                <form [formGroup]="emailForm">
                                    <div class="row">
                                        <div class="col-md-12 form-group">
                                            <div class="row">
                                                <div class="col-md-2">
                                                    <label class="form-label">To</label>
                                                </div>
                                                <!-- [ngClass]="{ 'is-invalid': f['to'].errors }" -->
                                                <div class="col-md-10">
                                                    <!-- <input type="text" class="form-control" formControlName="to"
                                                        name="to" id="to"> -->
                                                    <tag-input formControlName="to"
                                                        class="form-control tagInput-form-control" placeholder=""
                                                        secondaryPlaceholder="" [trimTags]="true" [addOnBlur]="true"
                                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal"
                                                        id="to" name="to" autocomplete="off" [addOnPaste]="true"
                                                        [pasteSplitPattern]="splitPattern"></tag-input>
                                                    <!-- <div *ngIf="f['to'].errors" class="invalid-feedback">
                                                            <div class="text-danger" *ngIf="f['to'].errors['required']">
                                                                Email is required</div>
                                                            <div class="text-danger" *ngIf="f['to'].errors['email']">Email is not Valid
                                                            </div>
                                                        </div> -->
                                                    <span class="text-danger"
                                                        *ngIf="emailForm.controls['to'].invalid && emailForm.controls['to'].dirty && emailForm.hasError('required','to')">
                                                        Email is required.
                                                    </span>
                                                    <span class="text-danger"
                                                        *ngIf="emailForm.controls['to'].invalid && emailForm.controls['to'].dirty && emailForm.hasError('pattern','to')">
                                                        Please enter valid email like (username&#64;gmail.com).
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 form-group">
                                            <div class="row">
                                                <div class="col-md-2">
                                                    <label class="form-label">CC</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <!-- <input type="text" class="form-control" formControlName="cc"
                                                        name="cc" id="cc"> -->
                                                    <tag-input formControlName="cc"
                                                        class="form-control tagInput-form-control" placeholder=""
                                                        secondaryPlaceholder="" [trimTags]="true" [addOnBlur]="true"
                                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal"
                                                        id="cc" name="cc" autocomplete="off" [addOnPaste]="true"
                                                        [pasteSplitPattern]="splitPattern"></tag-input>
                                                    <span class="text-danger"
                                                        *ngIf="emailForm.controls['cc'].invalid && emailForm.controls['cc'].dirty && emailForm.hasError('required','cc')">
                                                        Email is required.
                                                    </span>
                                                    <span class="text-danger"
                                                        *ngIf=" emailForm.controls['cc'].invalid && emailForm.controls['cc'].dirty && emailForm.hasError('pattern','cc')">
                                                        Please enter valid email like (username&#64;gmail.com).
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 form-group">
                                            <div class="row">
                                                <div class="col-md-2">
                                                    <label class="form-label">Subject</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <input type="text" class="form-control" formControlName="subject"
                                                        name="subject" id="subject">
                                                    <span class="text-danger"
                                                        *ngIf="emailForm.controls['subject'].invalid && emailForm.controls['subject'].dirty && emailForm.hasError('required','subject')">
                                                        Subject is required.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-10 offset-md-2">
                                            <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                                            <span class="sr-only">Loading...</span>
                                            <angular-editor formControlName="htmlContent" id="htmlContent"
                                                name="htmlContent" [config]="editorConfig"></angular-editor>
                                            <span class="text-danger"
                                                *ngIf="emailForm.controls['htmlContent'].invalid && emailForm.controls['htmlContent'].dirty && emailForm.hasError('required','htmlContent')">
                                                This field is required.
                                            </span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light cancelBtn" (click)="clearEmailData()"
                        data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary updateBtn" (click)="sendMailData()"
                        [disabled]="emailForm.invalid" data-bs-dismiss="modal">Update</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Dead air Modal Window -->
    <div class="modal fade" id="deadAirModal" tabindex="-1" aria-labelledby="deadAirModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="deadAirModalLabel"
                        *ngIf="this.deadAirDataNew[deadAirFileIndex]?.category === 'hold'">Hold</h4>
                    <h4 class="modal-title" id="deadAirModalLabel"
                        *ngIf="this.deadAirDataNew[deadAirFileIndex]?.category === 'deadair' || this.tableData[deadAirFileIndex]?.dead_air?.[0] ">
                        Dead Air</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearCallCategory()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <div class="card modalCard">
                        <div class="card-header">
                            <p>Details</p>
                        </div>
                        <div class="card-body">
                            <table class="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>S.no</th>
                                        <th>Start Time <span class="mins">(mm:ss)</span></th>
                                        <th>End Time <span class="mins">(mm:ss)</span></th>
                                        <th>Duration Time <span class="mins">(mm:ss)</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center" *ngIf="deadAirDurationData === []">
                                        <td colspan="3">
                                            <p class="noRecord">No Records Found</p>
                                    </tr>
                                    <tr *ngFor="let air of deadAirDurationData; index as i">
                                        <td>{{i+1}}</td>
                                        <td>{{air?.[0] | minuteSecondsPipe}}</td>
                                        <td>{{air?.[1] | minuteSecondsPipe}}</td>
                                        <td>{{ calculateDuration(air[1],air[0]) | minuteSecondsPipe}}</td>
                                        <!-- <td>{{air?.matched_keywords}} <p class="text-center"
                                                *ngIf="!call?.matched_keywords">-</p>
                                        </td> -->
                                    </tr>
                                    <tr>
                                        <td colspan="3" style="text-align: right;"><b>Total</b> </td>
                                        <td>{{softHold_Totalduration | minuteSecondsPipe}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Soft Hold Modal Window -->
    <div class="modal fade" id="softHoldModal" tabindex="-1" aria-labelledby="softHoldModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="softHoldModalLabel">Soft Hold</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearCallCategory()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <div class="card modalCard">
                        <div class="card-header">
                            <p>Details</p>
                        </div>
                        <div class="card-body">
                            <table class="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>S.no</th>
                                        <th>Start Time <span class="mins">(mm:ss)</span></th>
                                        <th>End Time <span class="mins">(mm:ss)</span></th>
                                        <th>Duration Time <span class="mins">(mm:ss)</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center" *ngIf="softHoldDurationData === []">
                                        <td colspan="3">
                                            <p class="noRecord">No Records Found</p>
                                        </td>    
                                    </tr>
                                    <tr *ngFor="let air of softHoldDurationData; index as i">
                                        <td>{{i+1}}</td>
                                        <td>{{air?.[0] | minuteSecondsPipe}}</td>
                                        <td>{{air?.[1] | minuteSecondsPipe}}</td>
                                        <td>{{ calculateDuration(air[1],air[0]) | minuteSecondsPipe}}</td>
                                        <!-- <td>{{air?.matched_keywords}} <p class="text-center"
                                                *ngIf="!call?.matched_keywords">-</p>
                                        </td> -->
                                    </tr>
                                    <tr>
                                        <td colspan="3" style="text-align: right;"><b>Total</b> </td>
                                        <td> {{softHold_Totalduration | minuteSecondsPipe}}</td>
                                    </tr>
                                 
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- translate modal window -->
    <div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="translateModal">
        <div class="modal-dialog modal-dialog-scrollable modal-xl transcriptModalWindow">
            <div class="modal-content translate-modal">
                <div class="modal-header">
                    <h4 class="modal-title">Translate Language</h4>
                    <div class="modal-header-second-part">
                        <i class="fa-solid fa-xmark exitIcon close " title="Close" data-bs-dismiss="modal"
                            aria-label="Close" (click)="clearTranslateModalData()"></i>
                    </div>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="text-center translate-heading">
                        <h4><b>{{displayName}} - Translate Text</b></h4>
                    </div>
                    <div class="container-fluid translate-container">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group language-form-group">
                                    <b class="from">From: </b>
                                    <ng-select [(ngModel)]="selectedTranslate_1" name="choosedLanguage"
                                        (change)="translateTextData(selectedTranslate_1)" class="lg-select-transcript"
                                        placeholder="" [clearable]="false" [readonly]="true" [attr.disabled]="true">
                                        <ng-option *ngFor="let data of tranlateLanguages" title="{{data.lang}}"
                                            [value]="data.value">{{data.lang}}</ng-option>
                                    </ng-select>
                                </div>

                                <div class="card translate-card">
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead class="tblHead">
                                                <tr>
                                                    <th class="speaker-name-tbl-head">Speaker</th>
                                                    <th>Transcript</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngIf="translateResponseData_original[0]?.spanish_edited_text">
                                                <tr *ngFor="let result of translateResponseData_original; index as i">
                                                    <td class="speakerName">{{result?.display_speaker}}</td>
                                                    <td [ngClass]="{'arabic':selectedTranslate_1==='Arabic'}">{{result?.spanish_edited_text}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-6">
                                <i *ngIf="translateSpinner"
                                    class="fa fa-spinner fa-pulse fa-3x fa-fw translate-spinner"></i>
                                <span class="sr-only">Loading...</span>
                                <div class="form-group">
                                    <b class="from">To: </b>
                                    <ng-select [(ngModel)]="selectedTranslate" name="choosedLanguage"
                                        (change)="translateTextData(selectedTranslate)" class="lg-select-transcript"
                                        placeholder="" [clearable]="false">
                                        <ng-option *ngFor="let data of tranlateLanguages" title="{{data.lang}}"
                                            [value]="data.value">{{data.lang}}</ng-option>
                                    </ng-select>
                                </div>
                                <div class="card translate-card">
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead class="tblHead">
                                                <tr>
                                                    <th class="speaker-name-tbl-head">Speaker</th>
                                                    <th>Transcript</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngIf="translateResponseData_original[0]?.spanish_edited_text">
                                                <tr *ngFor="let result of translateResponseData_original; index as i">
                                                    <td class="speakerName">{{result?.display_speaker}}</td>
                                                    <td [ngClass]="{'arabic':toLanguage==='ar'}">{{result?.edited_text}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

     <!--Questions Modal window -->
    <div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="questionModal">
        <div class="modal-dialog modal-dialog-scrollable {{modalScreenSize}} modal-xl transcriptModalWindow">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"><img src="../../../../assets/images/notes_ai_icon.svg" width="24" height="24">&nbsp; AI Generated</h4>
                    <div class="modal-header-second-part">
                        <i class="fa-solid fa-window-minimize min-max-icon" title="Minimize"
                            (click)="showMinimizedModal('Transcript')" data-bs-dismiss="modal" aria-label="Close"></i>
                        <i class="fa-solid fa-up-right-and-down-left-from-center min-max-icon" title="Full Screen"
                            *ngIf="!modalScreenSize" (click)="modalFullScreen('max')"></i>
                        <i class="fa-solid fa-down-left-and-up-right-to-center min-max-icon" title="Restore Down"
                            *ngIf="modalScreenSize" (click)="modalFullScreen('min')"></i>
                        <i class="fa-solid fa-xmark exitIcon close " title="Close"
                            (click)="clearKeywordDetailsTranscriptModal()" data-bs-dismiss="modal"
                            aria-label="Close"></i>
                    </div>
                </div>
                <div class="modal-body">
                    <!-- <ul class="nav nav-pills nav-justified border-bottom modalTitileTab" role="tablist">
                      
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'questions'}" href="#nav-questions"
                                data-bs-toggle="tab" role="tab" id="questions" (click)="modalHeading('questions')"
                                (click)="getTranscriptFun(fileIndex, 'questions')">Questions</a>
                        </li>
                      
                    </ul> -->
                    <div class="modal-subtitle border-bottom">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-8 tab-head">
                                   
                                    <h4 class="tabContentHeading">Questions</h4>
                                    
                                    <select (change)="changeTranscriptLgFun()" [(ngModel)]="transcribedLgVariable_T"
                                        name="" id="" class="form-select lg-select-transcript"
                                        *ngIf="showSelect_T && !spinner">
                                        <option *ngFor="let lg of transcribedLg_T" [value]="lg">{{lg}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-4 tab-head search-input-tab-head" *ngIf="showModal != 'dialogue' && showModal != 'summary'">
                                    <input type="search" class="form-control" placeholder="search keywords"
                                        [(ngModel)]="searchText">
                                    <i class="fa-solid fa-magnifying-glass userSearchLens"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Dialogue Contents -->
                    <div class="tab-content">
                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                        <span class="sr-only">Loading...</span>
                        
                       
                        <!-- question tab -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'questions','show':showModal === 'questions'}"
                            id="nav-questions" *ngIf="!spinner">
                            <div class="questionTab2" *ngIf="englishQuestions_T?.length == 0">
                                <p class="noRecord">No Records Found</p>
                            </div>
                            <div class="questionTab" *ngIf="englishQuestions_T?.length > 0">
                                <table>
                                    <tbody>
                                        <tr *ngFor="let question of englishQuestions_T ; index as i;"
                                            [appHighlightword]="searchText">
                                            <td class="numberTd">{{i+1}}.</td>
                                            @if(transcribedLgVariable_T === 'English'){
                                            <td>
                                                <p class="answerPara">
                                                    <!-- <b>{{"Q:("+question.question_speaker_name+")"}}</b> -->
                                                    {{question.question}}
                                                </p>
                                                <!-- <p> <b>{{"A:("+question.answer_speaker_name+")"}}</b>
                                                    {{question.answer}}</p> -->
                                            </td>
                                            } @else if(transcribedLgVariable_T === 'Arabic'){
                                                <td>
                                                <p class="answerPara">
                                                    <!-- <b>{{"Q:("+question.question_speaker_name+")"}}</b> -->
                                                    <span class="arabic">{{question.spanish_question}}</span>
                                                </p>
                                                <!-- <p> <b>{{"A:("+question.answer_speaker_name+")"}}</b>
                                                 <span class="arabic">    {{question.spanish_answer}} </span>
                                                </p> -->
                                            </td>
                                            } @else{
                                           
                                            <td>
                                                <p class="answerPara">
                                                    <!-- <b>{{"Q:("+question.question_speaker_name+")"}}</b> -->
                                                    {{question.spanish_question}}
                                                </p>
                                                <!-- <p> <b>{{"A:("+question.answer_speaker_name+")"}}</b>
                                                    {{question.spanish_answer}}</p> -->
                                            </td>
                                        }
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- delete modal for Delete table record-->
<div class="modal fade deleteModal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="exampleModalLabel">Delete File</h4>
                <i class="fa-solid fa-xmark exitIcon " data-bs-dismiss="modal" aria-label="Close"></i>
            </div>
            <div class="modal-body">
                Are you sure, you want to delete?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                <button type="button" class="btn btn-danger" (click)="deleteSelectRecord(getRecordIndex)"
                    data-bs-dismiss="modal" *ngIf="!showMultiSelect">Yes</button>
                <button type="button" class="btn btn-danger" (click)="deleteSelectRecord(7000)" data-bs-dismiss="modal"
                    *ngIf="showMultiSelect">Yess</button>
            </div>
        </div>
    </div>
</div>
<!-- audio tag modal for table record-->
<div class="modal deleteModal audioModal backdrop" id="audioModal" [ngClass]="{'s':display==='block'}" tabindex="-1"
    [ngStyle]="{'display':display}" aria-labelledby="audioModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="audioModalLabel">Notification</h4>
                <i class="fa-solid fa-xmark exitIcon " (click)="closeModalDialog()" data-bs-dismiss="modal"
                    aria-label="Close"></i>
            </div>
            <div class="modal-body">
                Audio will STOP playing, Yes to Continue?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                    (click)="closeModalDialog()">No</button>
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="closeAudioTag()"
                    (click)="closeModalDialog()">Yes</button>
            </div>
        </div>
    </div>
</div>